/*! @wharfkit/atomicassets v4.0.0-rc6 | BSD-3-Clause | Copyright (c) 2023 Greymass Inc. | https://github.com/wharfkit/js */
import { ABI, APIClient, Asset as Asset$1, Blob, Bytes, Checksum256, ExtendedAsset, FetchProvider, Float32, Float64, Int16, Int32, Int64, Int8, Name, PublicKey, Signature, Struct, UInt16, UInt32, UInt64, UInt8, Variant } from "@wharfkit/antelope";
import { Contract } from "@wharfkit/contract";
//#region \0rolldown/runtime.js
var __defProp = Object.defineProperty;
var __exportAll = (all, no_symbols) => {
	let target = {};
	for (var name in all) __defProp(target, name, {
		get: all[name],
		enumerable: true
	});
	if (!no_symbols) __defProp(target, Symbol.toStringTag, { value: "Module" });
	return target;
};
//#endregion
//#region \0@oxc-project+runtime@0.147.0/helpers/esm/decorate.js
function __decorate(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
}
//#endregion
//#region src/contracts/atomicassets.ts
var atomicassets_exports = __exportAll({
	Contract: () => Contract$3,
	TableMap: () => TableMap$2,
	Types: () => Types$2,
	abi: () => abi$2,
	abiBlob: () => abiBlob$2
});
const abiBlob$2 = Blob.from("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");
const abi$2 = ABI.from(abiBlob$2);
var Contract$3 = class extends Contract {
	constructor(args) {
		super({
			client: args.client,
			abi: abi$2,
			account: args.account || Name.from("atomicassets")
		});
	}
	action(name, data, options) {
		return super.action(name, data, options);
	}
	table(name, scope) {
		return super.table(name, scope, TableMap$2[name]);
	}
};
let Types$2;
(function(_Types) {
	let variant_int8_int16_int32_int64_uint8_uint16_uint32_uint64_float32_float64_string_INT8_VEC_INT16_VEC_INT32_VEC_INT64_VEC_UINT8_VEC_UINT16_VEC_UINT32_VEC_UINT64_VEC_FLOAT_VEC_DOUBLE_VEC_STRING_VEC = class variant_int8_int16_int32_int64_uint8_uint16_uint32_uint64_float32_float64_string_INT8_VEC_INT16_VEC_INT32_VEC_INT64_VEC_UINT8_VEC_UINT16_VEC_UINT32_VEC_UINT64_VEC_FLOAT_VEC_DOUBLE_VEC_STRING_VEC extends Variant {};
	variant_int8_int16_int32_int64_uint8_uint16_uint32_uint64_float32_float64_string_INT8_VEC_INT16_VEC_INT32_VEC_INT64_VEC_UINT8_VEC_UINT16_VEC_UINT32_VEC_UINT64_VEC_FLOAT_VEC_DOUBLE_VEC_STRING_VEC = __decorate([Variant.type("variant_int8_int16_int32_int64_uint8_uint16_uint32_uint64_float32_float64_string_INT8_VEC_INT16_VEC_INT32_VEC_INT64_VEC_UINT8_VEC_UINT16_VEC_UINT32_VEC_UINT64_VEC_FLOAT_VEC_DOUBLE_VEC_STRING_VEC", [
		Int8,
		Int16,
		Int32,
		Int64,
		UInt8,
		UInt16,
		UInt32,
		UInt64,
		Float32,
		Float64,
		"string",
		Bytes,
		{
			type: Int16,
			array: true
		},
		{
			type: Int32,
			array: true
		},
		{
			type: Int64,
			array: true
		},
		{
			type: UInt8,
			array: true
		},
		{
			type: UInt16,
			array: true
		},
		{
			type: UInt32,
			array: true
		},
		{
			type: UInt64,
			array: true
		},
		{
			type: Float32,
			array: true
		},
		{
			type: Float64,
			array: true
		},
		"string[]"
	])], variant_int8_int16_int32_int64_uint8_uint16_uint32_uint64_float32_float64_string_INT8_VEC_INT16_VEC_INT32_VEC_INT64_VEC_UINT8_VEC_UINT16_VEC_UINT32_VEC_UINT64_VEC_FLOAT_VEC_DOUBLE_VEC_STRING_VEC);
	_Types.variant_int8_int16_int32_int64_uint8_uint16_uint32_uint64_float32_float64_string_INT8_VEC_INT16_VEC_INT32_VEC_INT64_VEC_UINT8_VEC_UINT16_VEC_UINT32_VEC_UINT64_VEC_FLOAT_VEC_DOUBLE_VEC_STRING_VEC = variant_int8_int16_int32_int64_uint8_uint16_uint32_uint64_float32_float64_string_INT8_VEC_INT16_VEC_INT32_VEC_INT64_VEC_UINT8_VEC_UINT16_VEC_UINT32_VEC_UINT64_VEC_FLOAT_VEC_DOUBLE_VEC_STRING_VEC;
	let FORMAT = class FORMAT extends Struct {};
	__decorate([Struct.field("string")], FORMAT.prototype, "name", void 0);
	__decorate([Struct.field("string")], FORMAT.prototype, "type", void 0);
	FORMAT = __decorate([Struct.type("FORMAT")], FORMAT);
	_Types.FORMAT = FORMAT;
	let FORMAT_TYPE = class FORMAT_TYPE extends Struct {};
	__decorate([Struct.field("string")], FORMAT_TYPE.prototype, "name", void 0);
	__decorate([Struct.field("string")], FORMAT_TYPE.prototype, "mediatype", void 0);
	__decorate([Struct.field("string")], FORMAT_TYPE.prototype, "info", void 0);
	FORMAT_TYPE = __decorate([Struct.type("FORMAT_TYPE")], FORMAT_TYPE);
	_Types.FORMAT_TYPE = FORMAT_TYPE;
	let acceptauswap = class acceptauswap extends Struct {};
	__decorate([Struct.field(Name)], acceptauswap.prototype, "collection_name", void 0);
	acceptauswap = __decorate([Struct.type("acceptauswap")], acceptauswap);
	_Types.acceptauswap = acceptauswap;
	let acceptoffer = class acceptoffer extends Struct {};
	__decorate([Struct.field(UInt64)], acceptoffer.prototype, "offer_id", void 0);
	acceptoffer = __decorate([Struct.type("acceptoffer")], acceptoffer);
	_Types.acceptoffer = acceptoffer;
	let addcolauth = class addcolauth extends Struct {};
	__decorate([Struct.field(Name)], addcolauth.prototype, "collection_name", void 0);
	__decorate([Struct.field(Name)], addcolauth.prototype, "account_to_add", void 0);
	addcolauth = __decorate([Struct.type("addcolauth")], addcolauth);
	_Types.addcolauth = addcolauth;
	let addconftoken = class addconftoken extends Struct {};
	__decorate([Struct.field(Name)], addconftoken.prototype, "token_contract", void 0);
	__decorate([Struct.field(Asset$1.Symbol)], addconftoken.prototype, "token_symbol", void 0);
	addconftoken = __decorate([Struct.type("addconftoken")], addconftoken);
	_Types.addconftoken = addconftoken;
	let addnotifyacc = class addnotifyacc extends Struct {};
	__decorate([Struct.field(Name)], addnotifyacc.prototype, "collection_name", void 0);
	__decorate([Struct.field(Name)], addnotifyacc.prototype, "account_to_add", void 0);
	addnotifyacc = __decorate([Struct.type("addnotifyacc")], addnotifyacc);
	_Types.addnotifyacc = addnotifyacc;
	let admincoledit = class admincoledit extends Struct {};
	__decorate([Struct.field(FORMAT, { array: true })], admincoledit.prototype, "collection_format_extension", void 0);
	admincoledit = __decorate([Struct.type("admincoledit")], admincoledit);
	_Types.admincoledit = admincoledit;
	let announcedepo = class announcedepo extends Struct {};
	__decorate([Struct.field(Name)], announcedepo.prototype, "owner", void 0);
	__decorate([Struct.field(Asset$1.Symbol)], announcedepo.prototype, "symbol_to_announce", void 0);
	announcedepo = __decorate([Struct.type("announcedepo")], announcedepo);
	_Types.announcedepo = announcedepo;
	let assets_s = class assets_s extends Struct {};
	__decorate([Struct.field(UInt64)], assets_s.prototype, "asset_id", void 0);
	__decorate([Struct.field(Name)], assets_s.prototype, "collection_name", void 0);
	__decorate([Struct.field(Name)], assets_s.prototype, "schema_name", void 0);
	__decorate([Struct.field(Int32)], assets_s.prototype, "template_id", void 0);
	__decorate([Struct.field(Name)], assets_s.prototype, "ram_payer", void 0);
	__decorate([Struct.field(Asset$1, { array: true })], assets_s.prototype, "backed_tokens", void 0);
	__decorate([Struct.field(UInt8, { array: true })], assets_s.prototype, "immutable_serialized_data", void 0);
	__decorate([Struct.field(UInt8, { array: true })], assets_s.prototype, "mutable_serialized_data", void 0);
	assets_s = __decorate([Struct.type("assets_s")], assets_s);
	_Types.assets_s = assets_s;
	let author_swaps_s = class author_swaps_s extends Struct {};
	__decorate([Struct.field(Name)], author_swaps_s.prototype, "collection_name", void 0);
	__decorate([Struct.field(Name)], author_swaps_s.prototype, "current_author", void 0);
	__decorate([Struct.field(Name)], author_swaps_s.prototype, "new_author", void 0);
	__decorate([Struct.field(UInt32)], author_swaps_s.prototype, "acceptance_date", void 0);
	author_swaps_s = __decorate([Struct.type("author_swaps_s")], author_swaps_s);
	_Types.author_swaps_s = author_swaps_s;
	let backasset = class backasset extends Struct {};
	__decorate([Struct.field(Name)], backasset.prototype, "payer", void 0);
	__decorate([Struct.field(Name)], backasset.prototype, "asset_owner", void 0);
	__decorate([Struct.field(UInt64)], backasset.prototype, "asset_id", void 0);
	__decorate([Struct.field(Asset$1)], backasset.prototype, "token_to_back", void 0);
	backasset = __decorate([Struct.type("backasset")], backasset);
	_Types.backasset = backasset;
	let balances_s = class balances_s extends Struct {};
	__decorate([Struct.field(Name)], balances_s.prototype, "owner", void 0);
	__decorate([Struct.field(Asset$1, { array: true })], balances_s.prototype, "quantities", void 0);
	balances_s = __decorate([Struct.type("balances_s")], balances_s);
	_Types.balances_s = balances_s;
	let burnasset = class burnasset extends Struct {};
	__decorate([Struct.field(Name)], burnasset.prototype, "asset_owner", void 0);
	__decorate([Struct.field(UInt64)], burnasset.prototype, "asset_id", void 0);
	burnasset = __decorate([Struct.type("burnasset")], burnasset);
	_Types.burnasset = burnasset;
	let canceloffer = class canceloffer extends Struct {};
	__decorate([Struct.field(UInt64)], canceloffer.prototype, "offer_id", void 0);
	canceloffer = __decorate([Struct.type("canceloffer")], canceloffer);
	_Types.canceloffer = canceloffer;
	let collections_s = class collections_s extends Struct {};
	__decorate([Struct.field(Name)], collections_s.prototype, "collection_name", void 0);
	__decorate([Struct.field(Name)], collections_s.prototype, "author", void 0);
	__decorate([Struct.field("bool")], collections_s.prototype, "allow_notify", void 0);
	__decorate([Struct.field(Name, { array: true })], collections_s.prototype, "authorized_accounts", void 0);
	__decorate([Struct.field(Name, { array: true })], collections_s.prototype, "notify_accounts", void 0);
	__decorate([Struct.field(Float64)], collections_s.prototype, "market_fee", void 0);
	__decorate([Struct.field(UInt8, { array: true })], collections_s.prototype, "serialized_data", void 0);
	collections_s = __decorate([Struct.type("collections_s")], collections_s);
	_Types.collections_s = collections_s;
	let extended_symbol = class extended_symbol extends Struct {};
	__decorate([Struct.field(Asset$1.Symbol)], extended_symbol.prototype, "sym", void 0);
	__decorate([Struct.field(Name)], extended_symbol.prototype, "contract", void 0);
	extended_symbol = __decorate([Struct.type("extended_symbol")], extended_symbol);
	_Types.extended_symbol = extended_symbol;
	let config_s = class config_s extends Struct {};
	__decorate([Struct.field(UInt64)], config_s.prototype, "asset_counter", void 0);
	__decorate([Struct.field(Int32)], config_s.prototype, "template_counter", void 0);
	__decorate([Struct.field(UInt64)], config_s.prototype, "offer_counter", void 0);
	__decorate([Struct.field(FORMAT, { array: true })], config_s.prototype, "collection_format", void 0);
	__decorate([Struct.field(extended_symbol, { array: true })], config_s.prototype, "supported_tokens", void 0);
	config_s = __decorate([Struct.type("config_s")], config_s);
	_Types.config_s = config_s;
	let createauswap = class createauswap extends Struct {};
	__decorate([Struct.field(Name)], createauswap.prototype, "collection_name", void 0);
	__decorate([Struct.field(Name)], createauswap.prototype, "new_author", void 0);
	__decorate([Struct.field("bool")], createauswap.prototype, "owner", void 0);
	createauswap = __decorate([Struct.type("createauswap")], createauswap);
	_Types.createauswap = createauswap;
	let pair_string_ATOMIC_ATTRIBUTE = class pair_string_ATOMIC_ATTRIBUTE extends Struct {};
	__decorate([Struct.field("string")], pair_string_ATOMIC_ATTRIBUTE.prototype, "key", void 0);
	__decorate([Struct.field(variant_int8_int16_int32_int64_uint8_uint16_uint32_uint64_float32_float64_string_INT8_VEC_INT16_VEC_INT32_VEC_INT64_VEC_UINT8_VEC_UINT16_VEC_UINT32_VEC_UINT64_VEC_FLOAT_VEC_DOUBLE_VEC_STRING_VEC)], pair_string_ATOMIC_ATTRIBUTE.prototype, "value", void 0);
	pair_string_ATOMIC_ATTRIBUTE = __decorate([Struct.type("pair_string_ATOMIC_ATTRIBUTE")], pair_string_ATOMIC_ATTRIBUTE);
	_Types.pair_string_ATOMIC_ATTRIBUTE = pair_string_ATOMIC_ATTRIBUTE;
	let createcol = class createcol extends Struct {};
	__decorate([Struct.field(Name)], createcol.prototype, "author", void 0);
	__decorate([Struct.field(Name)], createcol.prototype, "collection_name", void 0);
	__decorate([Struct.field("bool")], createcol.prototype, "allow_notify", void 0);
	__decorate([Struct.field(Name, { array: true })], createcol.prototype, "authorized_accounts", void 0);
	__decorate([Struct.field(Name, { array: true })], createcol.prototype, "notify_accounts", void 0);
	__decorate([Struct.field(Float64)], createcol.prototype, "market_fee", void 0);
	__decorate([Struct.field(pair_string_ATOMIC_ATTRIBUTE, { array: true })], createcol.prototype, "data", void 0);
	createcol = __decorate([Struct.type("createcol")], createcol);
	_Types.createcol = createcol;
	let createoffer = class createoffer extends Struct {};
	__decorate([Struct.field(Name)], createoffer.prototype, "sender", void 0);
	__decorate([Struct.field(Name)], createoffer.prototype, "recipient", void 0);
	__decorate([Struct.field(UInt64, { array: true })], createoffer.prototype, "sender_asset_ids", void 0);
	__decorate([Struct.field(UInt64, { array: true })], createoffer.prototype, "recipient_asset_ids", void 0);
	__decorate([Struct.field("string")], createoffer.prototype, "memo", void 0);
	createoffer = __decorate([Struct.type("createoffer")], createoffer);
	_Types.createoffer = createoffer;
	let createschema = class createschema extends Struct {};
	__decorate([Struct.field(Name)], createschema.prototype, "authorized_creator", void 0);
	__decorate([Struct.field(Name)], createschema.prototype, "collection_name", void 0);
	__decorate([Struct.field(Name)], createschema.prototype, "schema_name", void 0);
	__decorate([Struct.field(FORMAT, { array: true })], createschema.prototype, "schema_format", void 0);
	createschema = __decorate([Struct.type("createschema")], createschema);
	_Types.createschema = createschema;
	let createtempl = class createtempl extends Struct {};
	__decorate([Struct.field(Name)], createtempl.prototype, "authorized_creator", void 0);
	__decorate([Struct.field(Name)], createtempl.prototype, "collection_name", void 0);
	__decorate([Struct.field(Name)], createtempl.prototype, "schema_name", void 0);
	__decorate([Struct.field("bool")], createtempl.prototype, "transferable", void 0);
	__decorate([Struct.field("bool")], createtempl.prototype, "burnable", void 0);
	__decorate([Struct.field(UInt32)], createtempl.prototype, "max_supply", void 0);
	__decorate([Struct.field(pair_string_ATOMIC_ATTRIBUTE, { array: true })], createtempl.prototype, "immutable_data", void 0);
	createtempl = __decorate([Struct.type("createtempl")], createtempl);
	_Types.createtempl = createtempl;
	let createtempl2 = class createtempl2 extends Struct {};
	__decorate([Struct.field(Name)], createtempl2.prototype, "authorized_creator", void 0);
	__decorate([Struct.field(Name)], createtempl2.prototype, "collection_name", void 0);
	__decorate([Struct.field(Name)], createtempl2.prototype, "schema_name", void 0);
	__decorate([Struct.field("bool")], createtempl2.prototype, "transferable", void 0);
	__decorate([Struct.field("bool")], createtempl2.prototype, "burnable", void 0);
	__decorate([Struct.field(UInt32)], createtempl2.prototype, "max_supply", void 0);
	__decorate([Struct.field(pair_string_ATOMIC_ATTRIBUTE, { array: true })], createtempl2.prototype, "immutable_data", void 0);
	__decorate([Struct.field(pair_string_ATOMIC_ATTRIBUTE, { array: true })], createtempl2.prototype, "mutable_data", void 0);
	createtempl2 = __decorate([Struct.type("createtempl2")], createtempl2);
	_Types.createtempl2 = createtempl2;
	let declineoffer = class declineoffer extends Struct {};
	__decorate([Struct.field(UInt64)], declineoffer.prototype, "offer_id", void 0);
	declineoffer = __decorate([Struct.type("declineoffer")], declineoffer);
	_Types.declineoffer = declineoffer;
	let deltemplate = class deltemplate extends Struct {};
	__decorate([Struct.field(Name)], deltemplate.prototype, "authorized_editor", void 0);
	__decorate([Struct.field(Name)], deltemplate.prototype, "collection_name", void 0);
	__decorate([Struct.field(Int32)], deltemplate.prototype, "template_id", void 0);
	deltemplate = __decorate([Struct.type("deltemplate")], deltemplate);
	_Types.deltemplate = deltemplate;
	let extendschema = class extendschema extends Struct {};
	__decorate([Struct.field(Name)], extendschema.prototype, "authorized_editor", void 0);
	__decorate([Struct.field(Name)], extendschema.prototype, "collection_name", void 0);
	__decorate([Struct.field(Name)], extendschema.prototype, "schema_name", void 0);
	__decorate([Struct.field(FORMAT, { array: true })], extendschema.prototype, "schema_format_extension", void 0);
	extendschema = __decorate([Struct.type("extendschema")], extendschema);
	_Types.extendschema = extendschema;
	let forbidnotify = class forbidnotify extends Struct {};
	__decorate([Struct.field(Name)], forbidnotify.prototype, "collection_name", void 0);
	forbidnotify = __decorate([Struct.type("forbidnotify")], forbidnotify);
	_Types.forbidnotify = forbidnotify;
	let init = class init extends Struct {};
	init = __decorate([Struct.type("init")], init);
	_Types.init = init;
	let locktemplate = class locktemplate extends Struct {};
	__decorate([Struct.field(Name)], locktemplate.prototype, "authorized_editor", void 0);
	__decorate([Struct.field(Name)], locktemplate.prototype, "collection_name", void 0);
	__decorate([Struct.field(Int32)], locktemplate.prototype, "template_id", void 0);
	locktemplate = __decorate([Struct.type("locktemplate")], locktemplate);
	_Types.locktemplate = locktemplate;
	let logbackasset = class logbackasset extends Struct {};
	__decorate([Struct.field(Name)], logbackasset.prototype, "asset_owner", void 0);
	__decorate([Struct.field(UInt64)], logbackasset.prototype, "asset_id", void 0);
	__decorate([Struct.field(Asset$1)], logbackasset.prototype, "backed_token", void 0);
	logbackasset = __decorate([Struct.type("logbackasset")], logbackasset);
	_Types.logbackasset = logbackasset;
	let logburnasset = class logburnasset extends Struct {};
	__decorate([Struct.field(Name)], logburnasset.prototype, "asset_owner", void 0);
	__decorate([Struct.field(UInt64)], logburnasset.prototype, "asset_id", void 0);
	__decorate([Struct.field(Name)], logburnasset.prototype, "collection_name", void 0);
	__decorate([Struct.field(Name)], logburnasset.prototype, "schema_name", void 0);
	__decorate([Struct.field(Int32)], logburnasset.prototype, "template_id", void 0);
	__decorate([Struct.field(Asset$1, { array: true })], logburnasset.prototype, "backed_tokens", void 0);
	__decorate([Struct.field(pair_string_ATOMIC_ATTRIBUTE, { array: true })], logburnasset.prototype, "old_immutable_data", void 0);
	__decorate([Struct.field(pair_string_ATOMIC_ATTRIBUTE, { array: true })], logburnasset.prototype, "old_mutable_data", void 0);
	__decorate([Struct.field(Name)], logburnasset.prototype, "asset_ram_payer", void 0);
	logburnasset = __decorate([Struct.type("logburnasset")], logburnasset);
	_Types.logburnasset = logburnasset;
	let logmint = class logmint extends Struct {};
	__decorate([Struct.field(UInt64)], logmint.prototype, "asset_id", void 0);
	__decorate([Struct.field(Name)], logmint.prototype, "authorized_minter", void 0);
	__decorate([Struct.field(Name)], logmint.prototype, "collection_name", void 0);
	__decorate([Struct.field(Name)], logmint.prototype, "schema_name", void 0);
	__decorate([Struct.field(Int32)], logmint.prototype, "template_id", void 0);
	__decorate([Struct.field(Name)], logmint.prototype, "new_asset_owner", void 0);
	__decorate([Struct.field(pair_string_ATOMIC_ATTRIBUTE, { array: true })], logmint.prototype, "immutable_data", void 0);
	__decorate([Struct.field(pair_string_ATOMIC_ATTRIBUTE, { array: true })], logmint.prototype, "mutable_data", void 0);
	__decorate([Struct.field(Asset$1, { array: true })], logmint.prototype, "backed_tokens", void 0);
	__decorate([Struct.field(pair_string_ATOMIC_ATTRIBUTE, { array: true })], logmint.prototype, "immutable_template_data", void 0);
	logmint = __decorate([Struct.type("logmint")], logmint);
	_Types.logmint = logmint;
	let lognewoffer = class lognewoffer extends Struct {};
	__decorate([Struct.field(UInt64)], lognewoffer.prototype, "offer_id", void 0);
	__decorate([Struct.field(Name)], lognewoffer.prototype, "sender", void 0);
	__decorate([Struct.field(Name)], lognewoffer.prototype, "recipient", void 0);
	__decorate([Struct.field(UInt64, { array: true })], lognewoffer.prototype, "sender_asset_ids", void 0);
	__decorate([Struct.field(UInt64, { array: true })], lognewoffer.prototype, "recipient_asset_ids", void 0);
	__decorate([Struct.field("string")], lognewoffer.prototype, "memo", void 0);
	lognewoffer = __decorate([Struct.type("lognewoffer")], lognewoffer);
	_Types.lognewoffer = lognewoffer;
	let lognewtempl = class lognewtempl extends Struct {};
	__decorate([Struct.field(Int32)], lognewtempl.prototype, "template_id", void 0);
	__decorate([Struct.field(Name)], lognewtempl.prototype, "authorized_creator", void 0);
	__decorate([Struct.field(Name)], lognewtempl.prototype, "collection_name", void 0);
	__decorate([Struct.field(Name)], lognewtempl.prototype, "schema_name", void 0);
	__decorate([Struct.field("bool")], lognewtempl.prototype, "transferable", void 0);
	__decorate([Struct.field("bool")], lognewtempl.prototype, "burnable", void 0);
	__decorate([Struct.field(UInt32)], lognewtempl.prototype, "max_supply", void 0);
	__decorate([Struct.field(pair_string_ATOMIC_ATTRIBUTE, { array: true })], lognewtempl.prototype, "immutable_data", void 0);
	lognewtempl = __decorate([Struct.type("lognewtempl")], lognewtempl);
	_Types.lognewtempl = lognewtempl;
	let logrampayer = class logrampayer extends Struct {};
	__decorate([Struct.field(Name)], logrampayer.prototype, "asset_owner", void 0);
	__decorate([Struct.field(UInt64)], logrampayer.prototype, "asset_id", void 0);
	__decorate([Struct.field(Name)], logrampayer.prototype, "old_ram_payer", void 0);
	__decorate([Struct.field(Name)], logrampayer.prototype, "new_ram_payer", void 0);
	logrampayer = __decorate([Struct.type("logrampayer")], logrampayer);
	_Types.logrampayer = logrampayer;
	let logsetdata = class logsetdata extends Struct {};
	__decorate([Struct.field(Name)], logsetdata.prototype, "asset_owner", void 0);
	__decorate([Struct.field(UInt64)], logsetdata.prototype, "asset_id", void 0);
	__decorate([Struct.field(pair_string_ATOMIC_ATTRIBUTE, { array: true })], logsetdata.prototype, "old_data", void 0);
	__decorate([Struct.field(pair_string_ATOMIC_ATTRIBUTE, { array: true })], logsetdata.prototype, "new_data", void 0);
	logsetdata = __decorate([Struct.type("logsetdata")], logsetdata);
	_Types.logsetdata = logsetdata;
	let logsetdatatl = class logsetdatatl extends Struct {};
	__decorate([Struct.field(Name)], logsetdatatl.prototype, "collection_name", void 0);
	__decorate([Struct.field(Name)], logsetdatatl.prototype, "schema_name", void 0);
	__decorate([Struct.field(Int32)], logsetdatatl.prototype, "template_id", void 0);
	__decorate([Struct.field(pair_string_ATOMIC_ATTRIBUTE, { array: true })], logsetdatatl.prototype, "old_data", void 0);
	__decorate([Struct.field(pair_string_ATOMIC_ATTRIBUTE, { array: true })], logsetdatatl.prototype, "new_data", void 0);
	logsetdatatl = __decorate([Struct.type("logsetdatatl")], logsetdatatl);
	_Types.logsetdatatl = logsetdatatl;
	let logtransfer = class logtransfer extends Struct {};
	__decorate([Struct.field(Name)], logtransfer.prototype, "collection_name", void 0);
	__decorate([Struct.field(Name)], logtransfer.prototype, "from", void 0);
	__decorate([Struct.field(Name)], logtransfer.prototype, "to", void 0);
	__decorate([Struct.field(UInt64, { array: true })], logtransfer.prototype, "asset_ids", void 0);
	__decorate([Struct.field("string")], logtransfer.prototype, "memo", void 0);
	logtransfer = __decorate([Struct.type("logtransfer")], logtransfer);
	_Types.logtransfer = logtransfer;
	let mintasset = class mintasset extends Struct {};
	__decorate([Struct.field(Name)], mintasset.prototype, "authorized_minter", void 0);
	__decorate([Struct.field(Name)], mintasset.prototype, "collection_name", void 0);
	__decorate([Struct.field(Name)], mintasset.prototype, "schema_name", void 0);
	__decorate([Struct.field(Int32)], mintasset.prototype, "template_id", void 0);
	__decorate([Struct.field(Name)], mintasset.prototype, "new_asset_owner", void 0);
	__decorate([Struct.field(pair_string_ATOMIC_ATTRIBUTE, { array: true })], mintasset.prototype, "immutable_data", void 0);
	__decorate([Struct.field(pair_string_ATOMIC_ATTRIBUTE, { array: true })], mintasset.prototype, "mutable_data", void 0);
	__decorate([Struct.field(Asset$1, { array: true })], mintasset.prototype, "tokens_to_back", void 0);
	mintasset = __decorate([Struct.type("mintasset")], mintasset);
	_Types.mintasset = mintasset;
	let offers_s = class offers_s extends Struct {};
	__decorate([Struct.field(UInt64)], offers_s.prototype, "offer_id", void 0);
	__decorate([Struct.field(Name)], offers_s.prototype, "sender", void 0);
	__decorate([Struct.field(Name)], offers_s.prototype, "recipient", void 0);
	__decorate([Struct.field(UInt64, { array: true })], offers_s.prototype, "sender_asset_ids", void 0);
	__decorate([Struct.field(UInt64, { array: true })], offers_s.prototype, "recipient_asset_ids", void 0);
	__decorate([Struct.field("string")], offers_s.prototype, "memo", void 0);
	__decorate([Struct.field(Name)], offers_s.prototype, "ram_payer", void 0);
	offers_s = __decorate([Struct.type("offers_s")], offers_s);
	_Types.offers_s = offers_s;
	let payofferram = class payofferram extends Struct {};
	__decorate([Struct.field(Name)], payofferram.prototype, "payer", void 0);
	__decorate([Struct.field(UInt64)], payofferram.prototype, "offer_id", void 0);
	payofferram = __decorate([Struct.type("payofferram")], payofferram);
	_Types.payofferram = payofferram;
	let redtemplmax = class redtemplmax extends Struct {};
	__decorate([Struct.field(Name)], redtemplmax.prototype, "authorized_editor", void 0);
	__decorate([Struct.field(Name)], redtemplmax.prototype, "collection_name", void 0);
	__decorate([Struct.field(Int32)], redtemplmax.prototype, "template_id", void 0);
	__decorate([Struct.field(UInt32)], redtemplmax.prototype, "new_max_supply", void 0);
	redtemplmax = __decorate([Struct.type("redtemplmax")], redtemplmax);
	_Types.redtemplmax = redtemplmax;
	let rejectauswap = class rejectauswap extends Struct {};
	__decorate([Struct.field(Name)], rejectauswap.prototype, "collection_name", void 0);
	rejectauswap = __decorate([Struct.type("rejectauswap")], rejectauswap);
	_Types.rejectauswap = rejectauswap;
	let remcolauth = class remcolauth extends Struct {};
	__decorate([Struct.field(Name)], remcolauth.prototype, "collection_name", void 0);
	__decorate([Struct.field(Name)], remcolauth.prototype, "account_to_remove", void 0);
	remcolauth = __decorate([Struct.type("remcolauth")], remcolauth);
	_Types.remcolauth = remcolauth;
	let remnotifyacc = class remnotifyacc extends Struct {};
	__decorate([Struct.field(Name)], remnotifyacc.prototype, "collection_name", void 0);
	__decorate([Struct.field(Name)], remnotifyacc.prototype, "account_to_remove", void 0);
	remnotifyacc = __decorate([Struct.type("remnotifyacc")], remnotifyacc);
	_Types.remnotifyacc = remnotifyacc;
	let schema_types_s = class schema_types_s extends Struct {};
	__decorate([Struct.field(Name)], schema_types_s.prototype, "schema_name", void 0);
	__decorate([Struct.field(FORMAT_TYPE, { array: true })], schema_types_s.prototype, "format_type", void 0);
	schema_types_s = __decorate([Struct.type("schema_types_s")], schema_types_s);
	_Types.schema_types_s = schema_types_s;
	let schemas_s = class schemas_s extends Struct {};
	__decorate([Struct.field(Name)], schemas_s.prototype, "schema_name", void 0);
	__decorate([Struct.field(FORMAT, { array: true })], schemas_s.prototype, "format", void 0);
	schemas_s = __decorate([Struct.type("schemas_s")], schemas_s);
	_Types.schemas_s = schemas_s;
	let setassetdata = class setassetdata extends Struct {};
	__decorate([Struct.field(Name)], setassetdata.prototype, "authorized_editor", void 0);
	__decorate([Struct.field(Name)], setassetdata.prototype, "asset_owner", void 0);
	__decorate([Struct.field(UInt64)], setassetdata.prototype, "asset_id", void 0);
	__decorate([Struct.field(pair_string_ATOMIC_ATTRIBUTE, { array: true })], setassetdata.prototype, "new_mutable_data", void 0);
	setassetdata = __decorate([Struct.type("setassetdata")], setassetdata);
	_Types.setassetdata = setassetdata;
	let setcoldata = class setcoldata extends Struct {};
	__decorate([Struct.field(Name)], setcoldata.prototype, "collection_name", void 0);
	__decorate([Struct.field(pair_string_ATOMIC_ATTRIBUTE, { array: true })], setcoldata.prototype, "data", void 0);
	setcoldata = __decorate([Struct.type("setcoldata")], setcoldata);
	_Types.setcoldata = setcoldata;
	let setlastpayer = class setlastpayer extends Struct {};
	__decorate([Struct.field(Name)], setlastpayer.prototype, "owner", void 0);
	__decorate([Struct.field(Name)], setlastpayer.prototype, "collection_name", void 0);
	setlastpayer = __decorate([Struct.type("setlastpayer")], setlastpayer);
	_Types.setlastpayer = setlastpayer;
	let setmarketfee = class setmarketfee extends Struct {};
	__decorate([Struct.field(Name)], setmarketfee.prototype, "collection_name", void 0);
	__decorate([Struct.field(Float64)], setmarketfee.prototype, "market_fee", void 0);
	setmarketfee = __decorate([Struct.type("setmarketfee")], setmarketfee);
	_Types.setmarketfee = setmarketfee;
	let setrampayer = class setrampayer extends Struct {};
	__decorate([Struct.field(Name)], setrampayer.prototype, "new_payer", void 0);
	__decorate([Struct.field(UInt64)], setrampayer.prototype, "asset_id", void 0);
	setrampayer = __decorate([Struct.type("setrampayer")], setrampayer);
	_Types.setrampayer = setrampayer;
	let setschematyp = class setschematyp extends Struct {};
	__decorate([Struct.field(Name)], setschematyp.prototype, "authorized_editor", void 0);
	__decorate([Struct.field(Name)], setschematyp.prototype, "collection_name", void 0);
	__decorate([Struct.field(Name)], setschematyp.prototype, "schema_name", void 0);
	__decorate([Struct.field(FORMAT_TYPE, { array: true })], setschematyp.prototype, "schema_format_type", void 0);
	setschematyp = __decorate([Struct.type("setschematyp")], setschematyp);
	_Types.setschematyp = setschematyp;
	let settempldata = class settempldata extends Struct {};
	__decorate([Struct.field(Name)], settempldata.prototype, "authorized_editor", void 0);
	__decorate([Struct.field(Name)], settempldata.prototype, "collection_name", void 0);
	__decorate([Struct.field(Int32)], settempldata.prototype, "template_id", void 0);
	__decorate([Struct.field(pair_string_ATOMIC_ATTRIBUTE, { array: true })], settempldata.prototype, "new_mutable_data", void 0);
	settempldata = __decorate([Struct.type("settempldata")], settempldata);
	_Types.settempldata = settempldata;
	let setversion = class setversion extends Struct {};
	__decorate([Struct.field("string")], setversion.prototype, "new_version", void 0);
	setversion = __decorate([Struct.type("setversion")], setversion);
	_Types.setversion = setversion;
	let template_mutables_s = class template_mutables_s extends Struct {};
	__decorate([Struct.field(Int32)], template_mutables_s.prototype, "template_id", void 0);
	__decorate([Struct.field(Name)], template_mutables_s.prototype, "schema_name", void 0);
	__decorate([Struct.field(UInt8, { array: true })], template_mutables_s.prototype, "mutable_serialized_data", void 0);
	template_mutables_s = __decorate([Struct.type("template_mutables_s")], template_mutables_s);
	_Types.template_mutables_s = template_mutables_s;
	let templates_s = class templates_s extends Struct {};
	__decorate([Struct.field(Int32)], templates_s.prototype, "template_id", void 0);
	__decorate([Struct.field(Name)], templates_s.prototype, "schema_name", void 0);
	__decorate([Struct.field("bool")], templates_s.prototype, "transferable", void 0);
	__decorate([Struct.field("bool")], templates_s.prototype, "burnable", void 0);
	__decorate([Struct.field(UInt32)], templates_s.prototype, "max_supply", void 0);
	__decorate([Struct.field(UInt32)], templates_s.prototype, "issued_supply", void 0);
	__decorate([Struct.field(UInt8, { array: true })], templates_s.prototype, "immutable_serialized_data", void 0);
	templates_s = __decorate([Struct.type("templates_s")], templates_s);
	_Types.templates_s = templates_s;
	let tokenconfigs_s = class tokenconfigs_s extends Struct {};
	__decorate([Struct.field(Name)], tokenconfigs_s.prototype, "standard", void 0);
	__decorate([Struct.field("string")], tokenconfigs_s.prototype, "version", void 0);
	tokenconfigs_s = __decorate([Struct.type("tokenconfigs_s")], tokenconfigs_s);
	_Types.tokenconfigs_s = tokenconfigs_s;
	let transfer = class transfer extends Struct {};
	__decorate([Struct.field(Name)], transfer.prototype, "from", void 0);
	__decorate([Struct.field(Name)], transfer.prototype, "to", void 0);
	__decorate([Struct.field(UInt64, { array: true })], transfer.prototype, "asset_ids", void 0);
	__decorate([Struct.field("string")], transfer.prototype, "memo", void 0);
	transfer = __decorate([Struct.type("transfer")], transfer);
	_Types.transfer = transfer;
	let withdraw = class withdraw extends Struct {};
	__decorate([Struct.field(Name)], withdraw.prototype, "owner", void 0);
	__decorate([Struct.field(Asset$1)], withdraw.prototype, "token_to_withdraw", void 0);
	withdraw = __decorate([Struct.type("withdraw")], withdraw);
	_Types.withdraw = withdraw;
})(Types$2 || (Types$2 = {}));
const TableMap$2 = {
	assets: Types$2.assets_s,
	authorswaps: Types$2.author_swaps_s,
	balances: Types$2.balances_s,
	collections: Types$2.collections_s,
	config: Types$2.config_s,
	offers: Types$2.offers_s,
	schemas: Types$2.schemas_s,
	schematypes: Types$2.schema_types_s,
	templates: Types$2.templates_s,
	templates2: Types$2.template_mutables_s,
	tokenconfigs: Types$2.tokenconfigs_s
};
//#endregion
//#region src/endpoints/types.ts
let OfferState = function(OfferState) {
	OfferState[OfferState["PENDING"] = 0] = "PENDING";
	OfferState[OfferState["INVALID"] = 1] = "INVALID";
	OfferState[OfferState["UNKNOWN"] = 2] = "UNKNOWN";
	OfferState[OfferState["ACCEPTED"] = 3] = "ACCEPTED";
	OfferState[OfferState["DECLINED"] = 4] = "DECLINED";
	OfferState[OfferState["CANCELLED"] = 5] = "CANCELLED";
	return OfferState;
}({});
let LinkState = function(LinkState) {
	LinkState[LinkState["WAITING"] = 0] = "WAITING";
	LinkState[LinkState["CREATED"] = 1] = "CREATED";
	LinkState[LinkState["CANCELED"] = 2] = "CANCELED";
	LinkState[LinkState["CLAIMED"] = 3] = "CLAIMED";
	return LinkState;
}({});
let AuctionState = function(AuctionState) {
	AuctionState[AuctionState["WAITING"] = 0] = "WAITING";
	AuctionState[AuctionState["LISTED"] = 1] = "LISTED";
	AuctionState[AuctionState["CANCELED"] = 2] = "CANCELED";
	AuctionState[AuctionState["SOLD"] = 3] = "SOLD";
	AuctionState[AuctionState["INVALID"] = 4] = "INVALID";
	return AuctionState;
}({});
let SaleState = function(SaleState) {
	SaleState[SaleState["WAITING"] = 0] = "WAITING";
	SaleState[SaleState["LISTED"] = 1] = "LISTED";
	SaleState[SaleState["CANCELED"] = 2] = "CANCELED";
	SaleState[SaleState["SOLD"] = 3] = "SOLD";
	SaleState[SaleState["INVALID"] = 4] = "INVALID";
	return SaleState;
}({});
let BuyofferState = function(BuyofferState) {
	BuyofferState[BuyofferState["PENDING"] = 0] = "PENDING";
	BuyofferState[BuyofferState["DECLINED"] = 1] = "DECLINED";
	BuyofferState[BuyofferState["CANCELED"] = 2] = "CANCELED";
	BuyofferState[BuyofferState["ACCEPTED"] = 3] = "ACCEPTED";
	BuyofferState[BuyofferState["INVALID"] = 4] = "INVALID";
	return BuyofferState;
}({});
let TemplateBuyofferState = function(TemplateBuyofferState) {
	TemplateBuyofferState[TemplateBuyofferState["LISTED"] = 0] = "LISTED";
	TemplateBuyofferState[TemplateBuyofferState["CANCELED"] = 1] = "CANCELED";
	TemplateBuyofferState[TemplateBuyofferState["SOLD"] = 2] = "SOLD";
	TemplateBuyofferState[TemplateBuyofferState["INVALID"] = 3] = "INVALID";
	return TemplateBuyofferState;
}({});
let Token = class Token extends Struct {};
__decorate([Struct.field(Name)], Token.prototype, "token_contract", void 0);
__decorate([Struct.field("string")], Token.prototype, "token_symbol", void 0);
__decorate([Struct.field(UInt8)], Token.prototype, "token_precision", void 0);
Token = __decorate([Struct.type("token")], Token);
let TokenAmount = class TokenAmount extends Token {};
__decorate([Struct.field(UInt64)], TokenAmount.prototype, "amount", void 0);
TokenAmount = __decorate([Struct.type("token_amount")], TokenAmount);
let TradingPair = class TradingPair extends Struct {};
__decorate([Struct.field("string")], TradingPair.prototype, "listing_symbol", void 0);
__decorate([Struct.field("string")], TradingPair.prototype, "settlement_symbol", void 0);
__decorate([Struct.field("string")], TradingPair.prototype, "delphi_pair_name", void 0);
__decorate([Struct.field("bool")], TradingPair.prototype, "invert_delphi_pair", void 0);
TradingPair = __decorate([Struct.type("trading_pair")], TradingPair);
let AtomicAssetsConfig = class AtomicAssetsConfig extends Struct {};
__decorate([Struct.field(Name)], AtomicAssetsConfig.prototype, "contract", void 0);
__decorate([Struct.field("string")], AtomicAssetsConfig.prototype, "version", void 0);
__decorate([Struct.field(Types$2.FORMAT, { array: true })], AtomicAssetsConfig.prototype, "collection_format", void 0);
__decorate([Struct.field(Token, { array: true })], AtomicAssetsConfig.prototype, "supported_tokens", void 0);
AtomicAssetsConfig = __decorate([Struct.type("atomicassets_config")], AtomicAssetsConfig);
let AtomicMarketConfig = class AtomicMarketConfig extends Struct {};
__decorate([Struct.field(Name)], AtomicMarketConfig.prototype, "atomicassets_contract", void 0);
__decorate([Struct.field(Name)], AtomicMarketConfig.prototype, "atomicmarket_contract", void 0);
__decorate([Struct.field(Name)], AtomicMarketConfig.prototype, "delphioracle_contract", void 0);
__decorate([Struct.field("string")], AtomicMarketConfig.prototype, "version", void 0);
__decorate([Struct.field(Float64)], AtomicMarketConfig.prototype, "maker_market_fee", void 0);
__decorate([Struct.field(Float64)], AtomicMarketConfig.prototype, "taker_market_fee", void 0);
__decorate([Struct.field(UInt64)], AtomicMarketConfig.prototype, "minimum_auction_duration", void 0);
__decorate([Struct.field(UInt64)], AtomicMarketConfig.prototype, "maximum_auction_duration", void 0);
__decorate([Struct.field(Float64)], AtomicMarketConfig.prototype, "minimum_bid_increase", void 0);
__decorate([Struct.field(UInt64)], AtomicMarketConfig.prototype, "auction_reset_duration", void 0);
__decorate([Struct.field(Token, { array: true })], AtomicMarketConfig.prototype, "supported_tokens", void 0);
__decorate([Struct.field(TradingPair, { array: true })], AtomicMarketConfig.prototype, "supported_pairs", void 0);
AtomicMarketConfig = __decorate([Struct.type("atomicmarket_config")], AtomicMarketConfig);
let AtomicToolsConfig = class AtomicToolsConfig extends Struct {};
__decorate([Struct.field(Name)], AtomicToolsConfig.prototype, "atomicassets_contract", void 0);
__decorate([Struct.field(Name)], AtomicToolsConfig.prototype, "atomictools_contract", void 0);
__decorate([Struct.field("string")], AtomicToolsConfig.prototype, "version", void 0);
AtomicToolsConfig = __decorate([Struct.type("atomictools_config")], AtomicToolsConfig);
let CollectionObject = class CollectionObject extends Struct {};
__decorate([Struct.field(Name, { optional: true })], CollectionObject.prototype, "contract", void 0);
__decorate([Struct.field(Name)], CollectionObject.prototype, "collection_name", void 0);
__decorate([Struct.field(Name)], CollectionObject.prototype, "author", void 0);
__decorate([Struct.field("bool")], CollectionObject.prototype, "allow_notify", void 0);
__decorate([Struct.field(Name, { array: true })], CollectionObject.prototype, "authorized_accounts", void 0);
__decorate([Struct.field(Name, { array: true })], CollectionObject.prototype, "notify_accounts", void 0);
__decorate([Struct.field(Float64)], CollectionObject.prototype, "market_fee", void 0);
__decorate([Struct.field("string", { optional: true })], CollectionObject.prototype, "name", void 0);
__decorate([Struct.field("string", { optional: true })], CollectionObject.prototype, "img", void 0);
__decorate([Struct.field("any", { optional: true })], CollectionObject.prototype, "data", void 0);
__decorate([Struct.field("string", { optional: true })], CollectionObject.prototype, "images", void 0);
__decorate([Struct.field(UInt64)], CollectionObject.prototype, "created_at_block", void 0);
__decorate([Struct.field("string")], CollectionObject.prototype, "created_at_time", void 0);
__decorate([Struct.field(Name, { optional: true })], CollectionObject.prototype, "new_author_name", void 0);
__decorate([Struct.field("string", { optional: true })], CollectionObject.prototype, "new_author_date", void 0);
CollectionObject = __decorate([Struct.type("collection_object")], CollectionObject);
let SchemaFormatField = class SchemaFormatField extends Struct {};
__decorate([Struct.field("string")], SchemaFormatField.prototype, "name", void 0);
__decorate([Struct.field("string")], SchemaFormatField.prototype, "type", void 0);
__decorate([Struct.field("string", { optional: true })], SchemaFormatField.prototype, "mediatype", void 0);
__decorate([Struct.field("string", { optional: true })], SchemaFormatField.prototype, "info", void 0);
SchemaFormatField = __decorate([Struct.type("schema_format_field")], SchemaFormatField);
let SchemaObject = class SchemaObject extends Struct {};
__decorate([Struct.field(Name)], SchemaObject.prototype, "schema_name", void 0);
__decorate([Struct.field(UInt64, { optional: true })], SchemaObject.prototype, "assets", void 0);
__decorate([Struct.field(SchemaFormatField, { array: true })], SchemaObject.prototype, "format", void 0);
__decorate([Struct.field(Name, { optional: true })], SchemaObject.prototype, "contract", void 0);
__decorate([Struct.field(Name, { optional: true })], SchemaObject.prototype, "collection_name", void 0);
__decorate([Struct.field(CollectionObject, { optional: true })], SchemaObject.prototype, "collection", void 0);
__decorate([Struct.field(UInt64)], SchemaObject.prototype, "created_at_block", void 0);
__decorate([Struct.field("string")], SchemaObject.prototype, "created_at_time", void 0);
SchemaObject = __decorate([Struct.type("schema_object")], SchemaObject);
let TemplateObject = class TemplateObject extends Struct {};
__decorate([Struct.field(Int32)], TemplateObject.prototype, "template_id", void 0);
__decorate([Struct.field("bool")], TemplateObject.prototype, "is_transferable", void 0);
__decorate([Struct.field("bool")], TemplateObject.prototype, "is_burnable", void 0);
__decorate([Struct.field(UInt32)], TemplateObject.prototype, "issued_supply", void 0);
__decorate([Struct.field(UInt32)], TemplateObject.prototype, "max_supply", void 0);
__decorate([Struct.field("any")], TemplateObject.prototype, "immutable_data", void 0);
__decorate([Struct.field(Name, { optional: true })], TemplateObject.prototype, "contract", void 0);
__decorate([Struct.field(CollectionObject, { optional: true })], TemplateObject.prototype, "collection", void 0);
__decorate([Struct.field(SchemaObject, { optional: true })], TemplateObject.prototype, "schema", void 0);
__decorate([Struct.field(UInt64)], TemplateObject.prototype, "created_at_block", void 0);
__decorate([Struct.field("string")], TemplateObject.prototype, "created_at_time", void 0);
__decorate([Struct.field("string", { optional: true })], TemplateObject.prototype, "name", void 0);
__decorate([Struct.field("any", { optional: true })], TemplateObject.prototype, "mutable_data", void 0);
__decorate([Struct.field("any", { optional: true })], TemplateObject.prototype, "data", void 0);
__decorate([Struct.field(UInt64, { optional: true })], TemplateObject.prototype, "deleted_at_block", void 0);
__decorate([Struct.field("string", { optional: true })], TemplateObject.prototype, "deleted_at_time", void 0);
TemplateObject = __decorate([Struct.type("template_object")], TemplateObject);
let AssetPriceV1 = class AssetPriceV1 extends Struct {};
__decorate([Struct.field("string")], AssetPriceV1.prototype, "token_symbol", void 0);
__decorate([Struct.field(UInt8)], AssetPriceV1.prototype, "token_precision", void 0);
__decorate([Struct.field(Name)], AssetPriceV1.prototype, "token_contract", void 0);
__decorate([Struct.field(UInt64)], AssetPriceV1.prototype, "median", void 0);
__decorate([Struct.field(UInt64)], AssetPriceV1.prototype, "average", void 0);
__decorate([Struct.field(UInt64)], AssetPriceV1.prototype, "suggested_median", void 0);
__decorate([Struct.field(UInt64)], AssetPriceV1.prototype, "suggested_average", void 0);
__decorate([Struct.field(UInt64)], AssetPriceV1.prototype, "max", void 0);
__decorate([Struct.field(UInt64)], AssetPriceV1.prototype, "min", void 0);
AssetPriceV1 = __decorate([Struct.type("assetpricev1")], AssetPriceV1);
let AssetPriceV2 = class AssetPriceV2 extends Struct {};
__decorate([Struct.field(Name)], AssetPriceV2.prototype, "market_contract", void 0);
__decorate([Struct.field(Token)], AssetPriceV2.prototype, "token", void 0);
__decorate([Struct.field(UInt64)], AssetPriceV2.prototype, "median", void 0);
__decorate([Struct.field(UInt64)], AssetPriceV2.prototype, "average", void 0);
__decorate([Struct.field(UInt64)], AssetPriceV2.prototype, "suggested_median", void 0);
__decorate([Struct.field(UInt64)], AssetPriceV2.prototype, "suggested_average", void 0);
__decorate([Struct.field(UInt64)], AssetPriceV2.prototype, "max", void 0);
__decorate([Struct.field(UInt64)], AssetPriceV2.prototype, "min", void 0);
__decorate([Struct.field(UInt64)], AssetPriceV2.prototype, "sales", void 0);
AssetPriceV2 = __decorate([Struct.type("assetpricev2")], AssetPriceV2);
let AssetObject = class AssetObject extends Struct {};
__decorate([Struct.field(UInt64)], AssetObject.prototype, "asset_id", void 0);
__decorate([Struct.field(CollectionObject)], AssetObject.prototype, "collection", void 0);
__decorate([Struct.field(SchemaObject)], AssetObject.prototype, "schema", void 0);
__decorate([Struct.field(TemplateObject, { optional: true })], AssetObject.prototype, "template", void 0);
__decorate([Struct.field(TokenAmount, { array: true })], AssetObject.prototype, "backed_tokens", void 0);
__decorate([Struct.field("any")], AssetObject.prototype, "immutable_data", void 0);
__decorate([Struct.field("any")], AssetObject.prototype, "mutable_data", void 0);
__decorate([Struct.field("any")], AssetObject.prototype, "data", void 0);
__decorate([Struct.field(Name, { optional: true })], AssetObject.prototype, "owner", void 0);
__decorate([Struct.field("bool")], AssetObject.prototype, "is_transferable", void 0);
__decorate([Struct.field("bool")], AssetObject.prototype, "is_burnable", void 0);
__decorate([Struct.field("string", { optional: true })], AssetObject.prototype, "name", void 0);
__decorate([Struct.field(Name, { optional: true })], AssetObject.prototype, "contract", void 0);
__decorate([Struct.field(Name, { optional: true })], AssetObject.prototype, "burned_by_account", void 0);
__decorate([Struct.field(UInt64, { optional: true })], AssetObject.prototype, "burned_at_block", void 0);
__decorate([Struct.field("string", { optional: true })], AssetObject.prototype, "burned_at_time", void 0);
__decorate([Struct.field(UInt32, { optional: true })], AssetObject.prototype, "template_mint", void 0);
__decorate([Struct.field(UInt64)], AssetObject.prototype, "updated_at_block", void 0);
__decorate([Struct.field("string")], AssetObject.prototype, "updated_at_time", void 0);
__decorate([Struct.field(UInt64)], AssetObject.prototype, "transferred_at_block", void 0);
__decorate([Struct.field("string")], AssetObject.prototype, "transferred_at_time", void 0);
__decorate([Struct.field(UInt64)], AssetObject.prototype, "minted_at_block", void 0);
__decorate([Struct.field("string")], AssetObject.prototype, "minted_at_time", void 0);
AssetObject = __decorate([Struct.type("asset_object")], AssetObject);
let OfferObject = class OfferObject extends Struct {};
__decorate([Struct.field(Name)], OfferObject.prototype, "contract", void 0);
__decorate([Struct.field(UInt64)], OfferObject.prototype, "offer_id", void 0);
__decorate([Struct.field(Name)], OfferObject.prototype, "sender_name", void 0);
__decorate([Struct.field(Name)], OfferObject.prototype, "recipient_name", void 0);
__decorate([Struct.field("string")], OfferObject.prototype, "memo", void 0);
__decorate([Struct.field(UInt8)], OfferObject.prototype, "state", void 0);
__decorate([Struct.field("bool")], OfferObject.prototype, "is_sender_contract", void 0);
__decorate([Struct.field("bool")], OfferObject.prototype, "is_recipient_contract", void 0);
__decorate([Struct.field(AssetObject, { array: true })], OfferObject.prototype, "sender_assets", void 0);
__decorate([Struct.field(AssetObject, { array: true })], OfferObject.prototype, "recipient_assets", void 0);
__decorate([Struct.field(UInt64)], OfferObject.prototype, "updated_at_block", void 0);
__decorate([Struct.field("string")], OfferObject.prototype, "updated_at_time", void 0);
__decorate([Struct.field(UInt64)], OfferObject.prototype, "created_at_block", void 0);
__decorate([Struct.field("string")], OfferObject.prototype, "created_at_time", void 0);
OfferObject = __decorate([Struct.type("offer_object")], OfferObject);
let TransferObject = class TransferObject extends Struct {};
__decorate([Struct.field(Name)], TransferObject.prototype, "contract", void 0);
__decorate([Struct.field(UInt64)], TransferObject.prototype, "transfer_id", void 0);
__decorate([Struct.field(Name)], TransferObject.prototype, "sender_name", void 0);
__decorate([Struct.field(Name)], TransferObject.prototype, "recipient_name", void 0);
__decorate([Struct.field("string")], TransferObject.prototype, "memo", void 0);
__decorate([Struct.field("string")], TransferObject.prototype, "txid", void 0);
__decorate([Struct.field(AssetObject, { array: true })], TransferObject.prototype, "assets", void 0);
__decorate([Struct.field(UInt64)], TransferObject.prototype, "created_at_block", void 0);
__decorate([Struct.field("string")], TransferObject.prototype, "created_at_time", void 0);
TransferObject = __decorate([Struct.type("transfer_object")], TransferObject);
let LinkObject = class LinkObject extends Struct {};
__decorate([Struct.field(Name)], LinkObject.prototype, "tools_contract", void 0);
__decorate([Struct.field(Name)], LinkObject.prototype, "assets_contract", void 0);
__decorate([Struct.field(UInt64)], LinkObject.prototype, "link_id", void 0);
__decorate([Struct.field(Name)], LinkObject.prototype, "creator", void 0);
__decorate([Struct.field(Name)], LinkObject.prototype, "claimer", void 0);
__decorate([Struct.field(UInt8)], LinkObject.prototype, "state", void 0);
__decorate([Struct.field(PublicKey)], LinkObject.prototype, "public_key", void 0);
__decorate([Struct.field("string")], LinkObject.prototype, "memo", void 0);
__decorate([Struct.field(AssetObject, { array: true })], LinkObject.prototype, "assets", void 0);
__decorate([Struct.field(UInt64)], LinkObject.prototype, "created_at_block", void 0);
__decorate([Struct.field("string")], LinkObject.prototype, "created_at_time", void 0);
__decorate([Struct.field(UInt64)], LinkObject.prototype, "updated_at_block", void 0);
__decorate([Struct.field("string")], LinkObject.prototype, "updated_at_time", void 0);
LinkObject = __decorate([Struct.type("link_object")], LinkObject);
let SaleBrief = class SaleBrief extends Struct {};
__decorate([Struct.field(Name)], SaleBrief.prototype, "market_contract", void 0);
__decorate([Struct.field(UInt64)], SaleBrief.prototype, "sale_id", void 0);
SaleBrief = __decorate([Struct.type("sale_brief")], SaleBrief);
let AuctionBrief = class AuctionBrief extends Struct {};
__decorate([Struct.field(Name)], AuctionBrief.prototype, "market_contract", void 0);
__decorate([Struct.field(UInt64)], AuctionBrief.prototype, "auction_id", void 0);
AuctionBrief = __decorate([Struct.type("aucttion_brief")], AuctionBrief);
let TemplateBuyofferBrief = class TemplateBuyofferBrief extends Struct {};
__decorate([Struct.field(Name)], TemplateBuyofferBrief.prototype, "market_contract", void 0);
__decorate([Struct.field(UInt64)], TemplateBuyofferBrief.prototype, "buyoffer_id", void 0);
__decorate([Struct.field("string")], TemplateBuyofferBrief.prototype, "token_symbol", void 0);
TemplateBuyofferBrief = __decorate([Struct.type("template_buyoffer")], TemplateBuyofferBrief);
let MarketAssetObject = class MarketAssetObject extends AssetObject {};
__decorate([Struct.field(SaleBrief, { array: true })], MarketAssetObject.prototype, "sales", void 0);
__decorate([Struct.field(AuctionBrief, { array: true })], MarketAssetObject.prototype, "auctions", void 0);
__decorate([Struct.field(AssetPriceV2, {
	array: true,
	optional: true
})], MarketAssetObject.prototype, "prices", void 0);
__decorate([Struct.field(TemplateBuyofferBrief, {
	array: true,
	optional: true
})], MarketAssetObject.prototype, "template_buyoffers", void 0);
MarketAssetObject = __decorate([Struct.type("market_asset_object")], MarketAssetObject);
let SaleObject = class SaleObject extends Struct {};
__decorate([Struct.field(Name)], SaleObject.prototype, "market_contract", void 0);
__decorate([Struct.field(Name)], SaleObject.prototype, "assets_contract", void 0);
__decorate([Struct.field(UInt64)], SaleObject.prototype, "sale_id", void 0);
__decorate([Struct.field(Name)], SaleObject.prototype, "seller", void 0);
__decorate([Struct.field(Name, { optional: true })], SaleObject.prototype, "buyer", void 0);
__decorate([Struct.field(UInt64)], SaleObject.prototype, "offer_id", void 0);
__decorate([Struct.field(TokenAmount)], SaleObject.prototype, "price", void 0);
__decorate([Struct.field(UInt64)], SaleObject.prototype, "listing_price", void 0);
__decorate([Struct.field("string")], SaleObject.prototype, "listing_symbol", void 0);
__decorate([Struct.field(MarketAssetObject, { array: true })], SaleObject.prototype, "assets", void 0);
__decorate([Struct.field("string", { optional: true })], SaleObject.prototype, "maker_marketplace", void 0);
__decorate([Struct.field("string", { optional: true })], SaleObject.prototype, "taker_marketplace", void 0);
__decorate([Struct.field(UInt8)], SaleObject.prototype, "state", void 0);
__decorate([Struct.field("bool")], SaleObject.prototype, "is_seller_contract", void 0);
__decorate([Struct.field(Name)], SaleObject.prototype, "collection_name", void 0);
__decorate([Struct.field(CollectionObject)], SaleObject.prototype, "collection", void 0);
__decorate([Struct.field(UInt64)], SaleObject.prototype, "updated_at_block", void 0);
__decorate([Struct.field("string")], SaleObject.prototype, "updated_at_time", void 0);
__decorate([Struct.field(UInt64)], SaleObject.prototype, "created_at_block", void 0);
__decorate([Struct.field("string")], SaleObject.prototype, "created_at_time", void 0);
__decorate([Struct.field(Float64, { optional: true })], SaleObject.prototype, "current_collection_fee", void 0);
SaleObject = __decorate([Struct.type("sale_object")], SaleObject);
let Bid = class Bid extends Struct {};
__decorate([Struct.field(Int64)], Bid.prototype, "number", void 0);
__decorate([Struct.field(Name)], Bid.prototype, "account", void 0);
__decorate([Struct.field(UInt64)], Bid.prototype, "amount", void 0);
__decorate([Struct.field(UInt64)], Bid.prototype, "created_at_block", void 0);
__decorate([Struct.field("string")], Bid.prototype, "created_at_time", void 0);
__decorate([Struct.field("string")], Bid.prototype, "txid", void 0);
Bid = __decorate([Struct.type("bid")], Bid);
let AuctionObject = class AuctionObject extends Struct {};
__decorate([Struct.field(Name)], AuctionObject.prototype, "market_contract", void 0);
__decorate([Struct.field(Name)], AuctionObject.prototype, "assets_contract", void 0);
__decorate([Struct.field(UInt64)], AuctionObject.prototype, "auction_id", void 0);
__decorate([Struct.field(Name)], AuctionObject.prototype, "seller", void 0);
__decorate([Struct.field(MarketAssetObject, { array: true })], AuctionObject.prototype, "assets", void 0);
__decorate([Struct.field("string")], AuctionObject.prototype, "end_time", void 0);
__decorate([Struct.field(TokenAmount)], AuctionObject.prototype, "price", void 0);
__decorate([Struct.field(Bid, { array: true })], AuctionObject.prototype, "bids", void 0);
__decorate([Struct.field(UInt8)], AuctionObject.prototype, "state", void 0);
__decorate([Struct.field(Name, { optional: true })], AuctionObject.prototype, "buyer", void 0);
__decorate([Struct.field("bool")], AuctionObject.prototype, "claimed_by_seller", void 0);
__decorate([Struct.field("bool")], AuctionObject.prototype, "claimed_by_buyer", void 0);
__decorate([Struct.field("string", { optional: true })], AuctionObject.prototype, "maker_marketplace", void 0);
__decorate([Struct.field("string", { optional: true })], AuctionObject.prototype, "taker_marketplace", void 0);
__decorate([Struct.field(CollectionObject)], AuctionObject.prototype, "collection", void 0);
__decorate([Struct.field("bool")], AuctionObject.prototype, "is_seller_contract", void 0);
__decorate([Struct.field(UInt64)], AuctionObject.prototype, "created_at_block", void 0);
__decorate([Struct.field("string")], AuctionObject.prototype, "created_at_time", void 0);
__decorate([Struct.field(UInt64)], AuctionObject.prototype, "updated_at_block", void 0);
__decorate([Struct.field("string")], AuctionObject.prototype, "updated_at_time", void 0);
AuctionObject = __decorate([Struct.type("auction_object")], AuctionObject);
let BuyofferObject = class BuyofferObject extends Struct {};
__decorate([Struct.field(Name)], BuyofferObject.prototype, "market_contract", void 0);
__decorate([Struct.field(Name)], BuyofferObject.prototype, "assets_contract", void 0);
__decorate([Struct.field(UInt64)], BuyofferObject.prototype, "buyoffer_id", void 0);
__decorate([Struct.field(Name)], BuyofferObject.prototype, "seller", void 0);
__decorate([Struct.field(Name)], BuyofferObject.prototype, "buyer", void 0);
__decorate([Struct.field(TokenAmount)], BuyofferObject.prototype, "price", void 0);
__decorate([Struct.field(AssetObject, { array: true })], BuyofferObject.prototype, "assets", void 0);
__decorate([Struct.field("string", { optional: true })], BuyofferObject.prototype, "maker_marketplace", void 0);
__decorate([Struct.field("string", { optional: true })], BuyofferObject.prototype, "taker_marketplace", void 0);
__decorate([Struct.field(CollectionObject)], BuyofferObject.prototype, "collection", void 0);
__decorate([Struct.field("string")], BuyofferObject.prototype, "memo", void 0);
__decorate([Struct.field("string", { optional: true })], BuyofferObject.prototype, "decline_memo", void 0);
__decorate([Struct.field(UInt64)], BuyofferObject.prototype, "created_at_block", void 0);
__decorate([Struct.field("string")], BuyofferObject.prototype, "created_at_time", void 0);
__decorate([Struct.field(UInt64)], BuyofferObject.prototype, "updated_at_block", void 0);
__decorate([Struct.field("string")], BuyofferObject.prototype, "updated_at_time", void 0);
__decorate([Struct.field(UInt8)], BuyofferObject.prototype, "state", void 0);
BuyofferObject = __decorate([Struct.type("buyoffer_object")], BuyofferObject);
let TemplateBuyofferObject = class TemplateBuyofferObject extends Struct {};
__decorate([Struct.field(Name)], TemplateBuyofferObject.prototype, "market_contract", void 0);
__decorate([Struct.field(Name)], TemplateBuyofferObject.prototype, "assets_contract", void 0);
__decorate([Struct.field(UInt64)], TemplateBuyofferObject.prototype, "buyoffer_id", void 0);
__decorate([Struct.field(Name, { optional: true })], TemplateBuyofferObject.prototype, "seller", void 0);
__decorate([Struct.field(Name)], TemplateBuyofferObject.prototype, "buyer", void 0);
__decorate([Struct.field(TokenAmount)], TemplateBuyofferObject.prototype, "price", void 0);
__decorate([Struct.field(AssetObject, { array: true })], TemplateBuyofferObject.prototype, "assets", void 0);
__decorate([Struct.field("string", { optional: true })], TemplateBuyofferObject.prototype, "maker_marketplace", void 0);
__decorate([Struct.field("string", { optional: true })], TemplateBuyofferObject.prototype, "taker_marketplace", void 0);
__decorate([Struct.field(CollectionObject)], TemplateBuyofferObject.prototype, "collection", void 0);
__decorate([Struct.field(TemplateObject)], TemplateBuyofferObject.prototype, "template", void 0);
__decorate([Struct.field(UInt64)], TemplateBuyofferObject.prototype, "created_at_block", void 0);
__decorate([Struct.field("string")], TemplateBuyofferObject.prototype, "created_at_time", void 0);
__decorate([Struct.field(UInt64)], TemplateBuyofferObject.prototype, "updated_at_block", void 0);
__decorate([Struct.field("string")], TemplateBuyofferObject.prototype, "updated_at_time", void 0);
__decorate([Struct.field(UInt8)], TemplateBuyofferObject.prototype, "state", void 0);
TemplateBuyofferObject = __decorate([Struct.type("template_buyoffer_object")], TemplateBuyofferObject);
let Marketplace = class Marketplace extends Struct {};
__decorate([Struct.field("string")], Marketplace.prototype, "marketplace_name", void 0);
__decorate([Struct.field(Name)], Marketplace.prototype, "creator", void 0);
__decorate([Struct.field(UInt64)], Marketplace.prototype, "created_at_block", void 0);
__decorate([Struct.field("string")], Marketplace.prototype, "created_at_time", void 0);
Marketplace = __decorate([Struct.type("marketplace")], Marketplace);
let SalePrice = class SalePrice extends Struct {};
__decorate([Struct.field(UInt64, { optional: true })], SalePrice.prototype, "sale_id", void 0);
__decorate([Struct.field(UInt64, { optional: true })], SalePrice.prototype, "auction_id", void 0);
__decorate([Struct.field(UInt64, { optional: true })], SalePrice.prototype, "buyoffer_id", void 0);
__decorate([Struct.field(UInt64)], SalePrice.prototype, "price", void 0);
__decorate([Struct.field(UInt32)], SalePrice.prototype, "template_mint", void 0);
__decorate([Struct.field("string")], SalePrice.prototype, "token_symbol", void 0);
__decorate([Struct.field(UInt8)], SalePrice.prototype, "token_precision", void 0);
__decorate([Struct.field(Name)], SalePrice.prototype, "token_contract", void 0);
__decorate([Struct.field("string")], SalePrice.prototype, "block_time", void 0);
SalePrice = __decorate([Struct.type("saleprice")], SalePrice);
let SalePriceDay = class SalePriceDay extends Struct {};
__decorate([Struct.field(UInt64)], SalePriceDay.prototype, "median", void 0);
__decorate([Struct.field(UInt64)], SalePriceDay.prototype, "average", void 0);
__decorate([Struct.field(UInt64)], SalePriceDay.prototype, "volume", void 0);
__decorate([Struct.field(UInt64)], SalePriceDay.prototype, "sales", void 0);
__decorate([Struct.field(UInt32, { optional: true })], SalePriceDay.prototype, "template_mint", void 0);
__decorate([Struct.field("string")], SalePriceDay.prototype, "token_symbol", void 0);
__decorate([Struct.field(UInt8)], SalePriceDay.prototype, "token_precision", void 0);
__decorate([Struct.field(Name)], SalePriceDay.prototype, "token_contract", void 0);
__decorate([Struct.field("string")], SalePriceDay.prototype, "time", void 0);
SalePriceDay = __decorate([Struct.type("salepriceday")], SalePriceDay);
let TemplatePrice = class TemplatePrice extends Struct {};
__decorate([Struct.field("string")], TemplatePrice.prototype, "token_symbol", void 0);
__decorate([Struct.field(UInt8)], TemplatePrice.prototype, "token_precision", void 0);
__decorate([Struct.field(Name)], TemplatePrice.prototype, "token_contract", void 0);
__decorate([Struct.field(Name)], TemplatePrice.prototype, "collection_name", void 0);
__decorate([Struct.field(Int32)], TemplatePrice.prototype, "template_id", void 0);
__decorate([Struct.field(UInt64)], TemplatePrice.prototype, "median", void 0);
__decorate([Struct.field(UInt64)], TemplatePrice.prototype, "average", void 0);
__decorate([Struct.field(UInt64)], TemplatePrice.prototype, "suggested_median", void 0);
__decorate([Struct.field(UInt64)], TemplatePrice.prototype, "suggested_average", void 0);
__decorate([Struct.field(UInt64)], TemplatePrice.prototype, "max", void 0);
__decorate([Struct.field(UInt64)], TemplatePrice.prototype, "min", void 0);
__decorate([Struct.field(UInt64)], TemplatePrice.prototype, "sales", void 0);
TemplatePrice = __decorate([Struct.type("templateprice")], TemplatePrice);
let CollectionPrice = class CollectionPrice extends Struct {};
__decorate([Struct.field("string")], CollectionPrice.prototype, "token_symbol", void 0);
__decorate([Struct.field(UInt8)], CollectionPrice.prototype, "token_precision", void 0);
__decorate([Struct.field(Name)], CollectionPrice.prototype, "token_contract", void 0);
__decorate([Struct.field(UInt64)], CollectionPrice.prototype, "median", void 0);
__decorate([Struct.field(UInt64)], CollectionPrice.prototype, "average", void 0);
__decorate([Struct.field(UInt64)], CollectionPrice.prototype, "suggested_median", void 0);
__decorate([Struct.field(UInt64)], CollectionPrice.prototype, "suggested_average", void 0);
__decorate([Struct.field(UInt64)], CollectionPrice.prototype, "max", void 0);
__decorate([Struct.field(UInt64)], CollectionPrice.prototype, "min", void 0);
CollectionPrice = __decorate([Struct.type("collectionprice")], CollectionPrice);
let CollectionWrapper = class CollectionWrapper extends Struct {};
__decorate([Struct.field(CollectionObject)], CollectionWrapper.prototype, "collection", void 0);
__decorate([Struct.field(UInt64, { optional: true })], CollectionWrapper.prototype, "assets", void 0);
__decorate([Struct.field(CollectionPrice, {
	array: true,
	optional: true
})], CollectionWrapper.prototype, "prices", void 0);
CollectionWrapper = __decorate([Struct.type("collection_wrapper")], CollectionWrapper);
let SchemaWrapper = class SchemaWrapper extends Struct {};
__decorate([Struct.field(SchemaObject)], SchemaWrapper.prototype, "schema", void 0);
__decorate([Struct.field(UInt64)], SchemaWrapper.prototype, "assets", void 0);
SchemaWrapper = __decorate([Struct.type("schema_wrapper")], SchemaWrapper);
let TemplateWrapper = class TemplateWrapper extends Struct {};
__decorate([Struct.field(TemplateObject)], TemplateWrapper.prototype, "template", void 0);
__decorate([Struct.field(Int32)], TemplateWrapper.prototype, "template_id", void 0);
__decorate([Struct.field(Name)], TemplateWrapper.prototype, "collection_name", void 0);
__decorate([Struct.field(UInt64)], TemplateWrapper.prototype, "assets", void 0);
TemplateWrapper = __decorate([Struct.type("template_wrapper")], TemplateWrapper);
let InventoryPrice = class InventoryPrice extends Struct {};
__decorate([Struct.field(CollectionWrapper, { array: true })], InventoryPrice.prototype, "collections", void 0);
InventoryPrice = __decorate([Struct.type("inventoryprice")], InventoryPrice);
let ActionLog = class ActionLog extends Struct {};
__decorate([Struct.field(UInt64)], ActionLog.prototype, "log_id", void 0);
__decorate([Struct.field(Name)], ActionLog.prototype, "name", void 0);
__decorate([Struct.field("any")], ActionLog.prototype, "data", void 0);
__decorate([Struct.field("string")], ActionLog.prototype, "txid", void 0);
__decorate([Struct.field(UInt64)], ActionLog.prototype, "created_at_block", void 0);
__decorate([Struct.field("string")], ActionLog.prototype, "created_at_time", void 0);
ActionLog = __decorate([Struct.type("action_log")], ActionLog);
let AccountInfo = class AccountInfo extends Struct {};
__decorate([Struct.field(CollectionWrapper, { array: true })], AccountInfo.prototype, "collections", void 0);
__decorate([Struct.field(SchemaWrapper, { array: true })], AccountInfo.prototype, "schemas", void 0);
__decorate([Struct.field(TemplateWrapper, { array: true })], AccountInfo.prototype, "templates", void 0);
__decorate([Struct.field(UInt64)], AccountInfo.prototype, "assets", void 0);
AccountInfo = __decorate([Struct.type("account_info")], AccountInfo);
let BurnedByTemplate = class BurnedByTemplate extends Struct {};
__decorate([Struct.field(UInt64)], BurnedByTemplate.prototype, "burned", void 0);
__decorate([Struct.field(Int32)], BurnedByTemplate.prototype, "template_id", void 0);
BurnedByTemplate = __decorate([Struct.type("burned_by_template")], BurnedByTemplate);
let BurnedBySchema = class BurnedBySchema extends Struct {};
__decorate([Struct.field(UInt64)], BurnedBySchema.prototype, "burned", void 0);
__decorate([Struct.field(Name)], BurnedBySchema.prototype, "schema_name", void 0);
BurnedBySchema = __decorate([Struct.type("burned_by_schema")], BurnedBySchema);
let CollectionStats = class CollectionStats extends Struct {};
__decorate([Struct.field(UInt64, { optional: true })], CollectionStats.prototype, "assets", void 0);
__decorate([Struct.field(UInt64, { optional: true })], CollectionStats.prototype, "burned", void 0);
__decorate([Struct.field(UInt64)], CollectionStats.prototype, "templates", void 0);
__decorate([Struct.field(UInt64)], CollectionStats.prototype, "schemas", void 0);
__decorate([Struct.field(BurnedByTemplate, { array: true })], CollectionStats.prototype, "burned_by_template", void 0);
__decorate([Struct.field(BurnedBySchema, { array: true })], CollectionStats.prototype, "burned_by_schema", void 0);
CollectionStats = __decorate([Struct.type("collection_stats")], CollectionStats);
let AssetStats = class AssetStats extends Struct {};
__decorate([Struct.field(UInt32)], AssetStats.prototype, "template_mint", void 0);
AssetStats = __decorate([Struct.type("asset_stats")], AssetStats);
let TemplateStats = class TemplateStats extends Struct {};
__decorate([Struct.field(UInt64)], TemplateStats.prototype, "assets", void 0);
__decorate([Struct.field(UInt64)], TemplateStats.prototype, "burned", void 0);
TemplateStats = __decorate([Struct.type("template_stats")], TemplateStats);
let SchemaStats = class SchemaStats extends Struct {};
__decorate([Struct.field(UInt64, { optional: true })], SchemaStats.prototype, "assets", void 0);
__decorate([Struct.field(UInt64, { optional: true })], SchemaStats.prototype, "burned", void 0);
__decorate([Struct.field(UInt64)], SchemaStats.prototype, "templates", void 0);
SchemaStats = __decorate([Struct.type("schema_stats")], SchemaStats);
let CollectionBurn = class CollectionBurn extends Struct {};
__decorate([Struct.field(Name)], CollectionBurn.prototype, "collection_name", void 0);
__decorate([Struct.field(UInt64)], CollectionBurn.prototype, "assets", void 0);
CollectionBurn = __decorate([Struct.type("collection_burn")], CollectionBurn);
let TemplateBurn = class TemplateBurn extends Struct {};
__decorate([Struct.field(Name)], TemplateBurn.prototype, "collection_name", void 0);
__decorate([Struct.field(Int32)], TemplateBurn.prototype, "template_id", void 0);
__decorate([Struct.field(UInt64)], TemplateBurn.prototype, "assets", void 0);
TemplateBurn = __decorate([Struct.type("template_burn")], TemplateBurn);
let AccountBurns = class AccountBurns extends Struct {};
__decorate([Struct.field(CollectionWrapper, { array: true })], AccountBurns.prototype, "collections", void 0);
__decorate([Struct.field(TemplateBurn, { array: true })], AccountBurns.prototype, "templates", void 0);
__decorate([Struct.field(UInt64)], AccountBurns.prototype, "assets", void 0);
AccountBurns = __decorate([Struct.type("account_burns")], AccountBurns);
let AssetSale = class AssetSale extends Struct {};
__decorate([Struct.field(UInt64, { optional: true })], AssetSale.prototype, "sale_id", void 0);
__decorate([Struct.field(UInt64, { optional: true })], AssetSale.prototype, "auction_id", void 0);
__decorate([Struct.field(UInt64, { optional: true })], AssetSale.prototype, "buyoffer_id", void 0);
__decorate([Struct.field(UInt64)], AssetSale.prototype, "price", void 0);
__decorate([Struct.field("string")], AssetSale.prototype, "token_symbol", void 0);
__decorate([Struct.field(UInt8)], AssetSale.prototype, "token_precision", void 0);
__decorate([Struct.field(Name)], AssetSale.prototype, "token_contract", void 0);
__decorate([Struct.field(Name)], AssetSale.prototype, "seller", void 0);
__decorate([Struct.field(Name)], AssetSale.prototype, "buyer", void 0);
__decorate([Struct.field("string")], AssetSale.prototype, "block_time", void 0);
AssetSale = __decorate([Struct.type("asset_sales")], AssetSale);
let ResponseStruct = class ResponseStruct extends Struct {};
__decorate([Struct.field("bool")], ResponseStruct.prototype, "success", void 0);
__decorate([Struct.field(Float64)], ResponseStruct.prototype, "query_time", void 0);
ResponseStruct = __decorate([Struct.type("resp")], ResponseStruct);
let CountResponseStruct = class CountResponseStruct extends ResponseStruct {};
__decorate([Struct.field(UInt64)], CountResponseStruct.prototype, "data", void 0);
CountResponseStruct = __decorate([Struct.type("get_count_resp")], CountResponseStruct);
//#endregion
//#region src/endpoints/assets/types.ts
var types_exports$3 = __exportAll({
	AccountAssets: () => AccountAssets,
	ActionLogsResponse: () => ActionLogsResponse$2,
	CollectionSchema: () => CollectionSchema,
	GetAccountBurnsResponse: () => GetAccountBurnsResponse,
	GetAccountResponse: () => GetAccountResponse,
	GetAccountTemplateSchemaCountResponse: () => GetAccountTemplateSchemaCountResponse,
	GetAccountsResponse: () => GetAccountsResponse,
	GetAssetResponse: () => GetAssetResponse$1,
	GetAssetStatsResponse: () => GetAssetStatsResponse$1,
	GetAssetsResponse: () => GetAssetsResponse$1,
	GetCollectionResponse: () => GetCollectionResponse,
	GetCollectionSchemasResponse: () => GetCollectionSchemasResponse,
	GetCollectionStatsResponse: () => GetCollectionStatsResponse,
	GetCollectionsResponse: () => GetCollectionsResponse,
	GetConfigResponse: () => GetConfigResponse$2,
	GetOfferResponse: () => GetOfferResponse$1,
	GetOffersResponse: () => GetOffersResponse$1,
	GetSchemaResponse: () => GetSchemaResponse,
	GetSchemaStatsResponse: () => GetSchemaStatsResponse,
	GetSchemasResponse: () => GetSchemasResponse,
	GetTemplateResponse: () => GetTemplateResponse,
	GetTemplateStatsResponse: () => GetTemplateStatsResponse,
	GetTemplatesResponse: () => GetTemplatesResponse,
	GetTransfersResponse: () => GetTransfersResponse$1,
	SchemaCount: () => SchemaCount,
	TemplateCount: () => TemplateCount,
	TemplateSchemaCount: () => TemplateSchemaCount
});
let AccountAssets = class AccountAssets extends Struct {};
__decorate([Struct.field(Name)], AccountAssets.prototype, "account", void 0);
__decorate([Struct.field(UInt64)], AccountAssets.prototype, "assets", void 0);
AccountAssets = __decorate([Struct.type("account_assets")], AccountAssets);
let ActionLogsResponse$2 = class ActionLogsResponse extends ResponseStruct {};
__decorate([Struct.field(ActionLog, { array: true })], ActionLogsResponse$2.prototype, "data", void 0);
ActionLogsResponse$2 = __decorate([Struct.type("action_logs_resp")], ActionLogsResponse$2);
let GetConfigResponse$2 = class GetConfigResponse extends ResponseStruct {};
__decorate([Struct.field(AtomicAssetsConfig)], GetConfigResponse$2.prototype, "data", void 0);
GetConfigResponse$2 = __decorate([Struct.type("get_config_resp")], GetConfigResponse$2);
let GetAccountsResponse = class GetAccountsResponse extends ResponseStruct {};
__decorate([Struct.field(AccountAssets, { array: true })], GetAccountsResponse.prototype, "data", void 0);
GetAccountsResponse = __decorate([Struct.type("get_accounts_resp")], GetAccountsResponse);
let GetAccountResponse = class GetAccountResponse extends ResponseStruct {};
__decorate([Struct.field(AccountInfo)], GetAccountResponse.prototype, "data", void 0);
GetAccountResponse = __decorate([Struct.type("get_account_resp")], GetAccountResponse);
let SchemaCount = class SchemaCount extends Struct {};
__decorate([Struct.field(Name)], SchemaCount.prototype, "schema_name", void 0);
__decorate([Struct.field(UInt64)], SchemaCount.prototype, "assets", void 0);
SchemaCount = __decorate([Struct.type("schema_count")], SchemaCount);
let CollectionSchema = class CollectionSchema extends Struct {};
__decorate([Struct.field(Name)], CollectionSchema.prototype, "schema_name", void 0);
CollectionSchema = __decorate([Struct.type("collection_schema")], CollectionSchema);
let TemplateCount = class TemplateCount extends Struct {};
__decorate([Struct.field(Int32)], TemplateCount.prototype, "template_id", void 0);
__decorate([Struct.field(UInt64)], TemplateCount.prototype, "assets", void 0);
TemplateCount = __decorate([Struct.type("template_count")], TemplateCount);
let TemplateSchemaCount = class TemplateSchemaCount extends Struct {};
__decorate([Struct.field(SchemaCount, { array: true })], TemplateSchemaCount.prototype, "schemas", void 0);
__decorate([Struct.field(TemplateCount, { array: true })], TemplateSchemaCount.prototype, "templates", void 0);
TemplateSchemaCount = __decorate([Struct.type("template_schema_count")], TemplateSchemaCount);
let GetAccountTemplateSchemaCountResponse = class GetAccountTemplateSchemaCountResponse extends ResponseStruct {};
__decorate([Struct.field(TemplateSchemaCount)], GetAccountTemplateSchemaCountResponse.prototype, "data", void 0);
GetAccountTemplateSchemaCountResponse = __decorate([Struct.type("get_account_template_schema_count_resp")], GetAccountTemplateSchemaCountResponse);
let GetCollectionsResponse = class GetCollectionsResponse extends ResponseStruct {};
__decorate([Struct.field(CollectionObject, { array: true })], GetCollectionsResponse.prototype, "data", void 0);
GetCollectionsResponse = __decorate([Struct.type("get_collections_resp")], GetCollectionsResponse);
let GetCollectionResponse = class GetCollectionResponse extends ResponseStruct {};
__decorate([Struct.field(CollectionObject)], GetCollectionResponse.prototype, "data", void 0);
GetCollectionResponse = __decorate([Struct.type("get_collection_resp")], GetCollectionResponse);
let GetCollectionStatsResponse = class GetCollectionStatsResponse extends ResponseStruct {};
__decorate([Struct.field(CollectionStats)], GetCollectionStatsResponse.prototype, "data", void 0);
GetCollectionStatsResponse = __decorate([Struct.type("get_collection_stats_resp")], GetCollectionStatsResponse);
let GetCollectionSchemasResponse = class GetCollectionSchemasResponse extends ResponseStruct {};
__decorate([Struct.field(CollectionSchema, { array: true })], GetCollectionSchemasResponse.prototype, "data", void 0);
GetCollectionSchemasResponse = __decorate([Struct.type("get_collection_schemas_resp")], GetCollectionSchemasResponse);
let GetSchemasResponse = class GetSchemasResponse extends ResponseStruct {};
__decorate([Struct.field(SchemaObject, { array: true })], GetSchemasResponse.prototype, "data", void 0);
GetSchemasResponse = __decorate([Struct.type("get_schemas_resp")], GetSchemasResponse);
let GetSchemaResponse = class GetSchemaResponse extends ResponseStruct {};
__decorate([Struct.field(SchemaObject)], GetSchemaResponse.prototype, "data", void 0);
GetSchemaResponse = __decorate([Struct.type("get_schema_resp")], GetSchemaResponse);
let GetSchemaStatsResponse = class GetSchemaStatsResponse extends ResponseStruct {};
__decorate([Struct.field(SchemaStats)], GetSchemaStatsResponse.prototype, "data", void 0);
GetSchemaStatsResponse = __decorate([Struct.type("get_schema_stats_resp")], GetSchemaStatsResponse);
let GetTemplatesResponse = class GetTemplatesResponse extends ResponseStruct {};
__decorate([Struct.field(TemplateObject, { array: true })], GetTemplatesResponse.prototype, "data", void 0);
GetTemplatesResponse = __decorate([Struct.type("get_templates_resp")], GetTemplatesResponse);
let GetTemplateResponse = class GetTemplateResponse extends ResponseStruct {};
__decorate([Struct.field(TemplateObject)], GetTemplateResponse.prototype, "data", void 0);
GetTemplateResponse = __decorate([Struct.type("get_template_resp")], GetTemplateResponse);
let GetTemplateStatsResponse = class GetTemplateStatsResponse extends ResponseStruct {};
__decorate([Struct.field(TemplateStats)], GetTemplateStatsResponse.prototype, "data", void 0);
GetTemplateStatsResponse = __decorate([Struct.type("get_template_stats_resp")], GetTemplateStatsResponse);
let GetAssetsResponse$1 = class GetAssetsResponse extends ResponseStruct {};
__decorate([Struct.field(AssetObject, { array: true })], GetAssetsResponse$1.prototype, "data", void 0);
GetAssetsResponse$1 = __decorate([Struct.type("get_assets_resp")], GetAssetsResponse$1);
let GetAssetResponse$1 = class GetAssetResponse extends ResponseStruct {};
__decorate([Struct.field(AssetObject)], GetAssetResponse$1.prototype, "data", void 0);
GetAssetResponse$1 = __decorate([Struct.type("get_asset_resp")], GetAssetResponse$1);
let GetAssetStatsResponse$1 = class GetAssetStatsResponse extends ResponseStruct {};
__decorate([Struct.field(AssetStats)], GetAssetStatsResponse$1.prototype, "data", void 0);
GetAssetStatsResponse$1 = __decorate([Struct.type("get_asset_stats_resp")], GetAssetStatsResponse$1);
let GetOffersResponse$1 = class GetOffersResponse extends ResponseStruct {};
__decorate([Struct.field(OfferObject, { array: true })], GetOffersResponse$1.prototype, "data", void 0);
GetOffersResponse$1 = __decorate([Struct.type("get_offers_resp")], GetOffersResponse$1);
let GetOfferResponse$1 = class GetOfferResponse extends ResponseStruct {};
__decorate([Struct.field(OfferObject)], GetOfferResponse$1.prototype, "data", void 0);
GetOfferResponse$1 = __decorate([Struct.type("get_offer_resp")], GetOfferResponse$1);
let GetTransfersResponse$1 = class GetTransfersResponse extends ResponseStruct {};
__decorate([Struct.field(TransferObject, { array: true })], GetTransfersResponse$1.prototype, "data", void 0);
GetTransfersResponse$1 = __decorate([Struct.type("get_transfers_resp")], GetTransfersResponse$1);
let GetAccountBurnsResponse = class GetAccountBurnsResponse extends ResponseStruct {};
__decorate([Struct.field(AccountBurns)], GetAccountBurnsResponse.prototype, "data", void 0);
GetAccountBurnsResponse = __decorate([Struct.type("get_account_burns_resp")], GetAccountBurnsResponse);
//#endregion
//#region src/endpoints/market/types.ts
var types_exports$2 = __exportAll({
	AccountStat: () => AccountStat,
	ActionLogsResponse: () => ActionLogsResponse$1,
	CollectionStat: () => CollectionStat,
	GetAssetPricesResponse: () => GetAssetPricesResponse,
	GetAssetResponse: () => GetAssetResponse,
	GetAssetSalesResponse: () => GetAssetSalesResponse,
	GetAssetStatsResponse: () => GetAssetStatsResponse,
	GetAssetsResponse: () => GetAssetsResponse,
	GetAuctionResponse: () => GetAuctionResponse,
	GetAuctionsResponse: () => GetAuctionsResponse,
	GetBuyofferResponse: () => GetBuyofferResponse,
	GetBuyoffersResponse: () => GetBuyoffersResponse,
	GetConfigResponse: () => GetConfigResponse$1,
	GetInventoryPricesResponse: () => GetInventoryPricesResponse,
	GetMarketplaceResponse: () => GetMarketplaceResponse,
	GetMarketplacesResponse: () => GetMarketplacesResponse,
	GetOfferResponse: () => GetOfferResponse,
	GetOffersResponse: () => GetOffersResponse,
	GetSalePricesDaysResponse: () => GetSalePricesDaysResponse,
	GetSalePricesResponse: () => GetSalePricesResponse,
	GetSaleResponse: () => GetSaleResponse,
	GetSalesResponse: () => GetSalesResponse,
	GetSalesTemplatesResponse: () => GetSalesTemplatesResponse,
	GetStatsAccountResponse: () => GetStatsAccountResponse,
	GetStatsAccountsResponse: () => GetStatsAccountsResponse,
	GetStatsCollectionResponse: () => GetStatsCollectionResponse,
	GetStatsCollectionsResponse: () => GetStatsCollectionsResponse,
	GetStatsGraphResponse: () => GetStatsGraphResponse,
	GetStatsSalesResponse: () => GetStatsSalesResponse,
	GetStatsSchemasV1Response: () => GetStatsSchemasV1Response,
	GetStatsSchemasV2Response: () => GetStatsSchemasV2Response,
	GetStatsTemplatesResponse: () => GetStatsTemplatesResponse,
	GetTemplateBuyofferResponse: () => GetTemplateBuyofferResponse,
	GetTemplateBuyoffersResponse: () => GetTemplateBuyoffersResponse,
	GetTemplatePricesResponse: () => GetTemplatePricesResponse,
	GetTransfersResponse: () => GetTransfersResponse,
	GraphStat: () => GraphStat,
	MarketAccount: () => MarketAccount,
	MarketAccounts: () => MarketAccounts,
	MarketCollection: () => MarketCollection,
	MarketCollections: () => MarketCollections,
	MarketGraph: () => MarketGraph,
	MarketSale: () => MarketSale,
	MarketSchemasV1: () => MarketSchemasV1,
	MarketSchemasV2: () => MarketSchemasV2,
	MarketTemplates: () => MarketTemplates,
	SaleStat: () => SaleStat,
	SchemaStatV1: () => SchemaStatV1,
	SchemaStatV2: () => SchemaStatV2,
	TemplateStat: () => TemplateStat
});
let CollectionStat = class CollectionStat extends CollectionObject {};
__decorate([Struct.field(UInt64)], CollectionStat.prototype, "volume", void 0);
__decorate([Struct.field(UInt64)], CollectionStat.prototype, "sales", void 0);
__decorate([Struct.field(UInt64, { optional: true })], CollectionStat.prototype, "listings", void 0);
CollectionStat = __decorate([Struct.type("collection_stat")], CollectionStat);
let TemplateStat = class TemplateStat extends Struct {};
__decorate([Struct.field(UInt64)], TemplateStat.prototype, "volume", void 0);
__decorate([Struct.field(UInt64)], TemplateStat.prototype, "sales", void 0);
__decorate([Struct.field(UInt64, { optional: true })], TemplateStat.prototype, "listings", void 0);
__decorate([Struct.field(TemplateObject)], TemplateStat.prototype, "template", void 0);
TemplateStat = __decorate([Struct.type("template_stat")], TemplateStat);
let MarketTemplates = class MarketTemplates extends Struct {};
__decorate([Struct.field(Token)], MarketTemplates.prototype, "symbol", void 0);
__decorate([Struct.field(TemplateStat, { array: true })], MarketTemplates.prototype, "results", void 0);
MarketTemplates = __decorate([Struct.type("market_templates")], MarketTemplates);
let GraphStat = class GraphStat extends Struct {};
__decorate([Struct.field(UInt64)], GraphStat.prototype, "volume", void 0);
__decorate([Struct.field(UInt64)], GraphStat.prototype, "sales", void 0);
__decorate([Struct.field(UInt64, { optional: true })], GraphStat.prototype, "listings", void 0);
__decorate([Struct.field(UInt64)], GraphStat.prototype, "max", void 0);
__decorate([Struct.field("string")], GraphStat.prototype, "time", void 0);
GraphStat = __decorate([Struct.type("graph_stat")], GraphStat);
let MarketGraph = class MarketGraph extends Struct {};
__decorate([Struct.field(Token)], MarketGraph.prototype, "symbol", void 0);
__decorate([Struct.field(GraphStat, { array: true })], MarketGraph.prototype, "results", void 0);
MarketGraph = __decorate([Struct.type("market_graph")], MarketGraph);
let SaleStat = class SaleStat extends Struct {};
__decorate([Struct.field(UInt64, { optional: true })], SaleStat.prototype, "volume", void 0);
__decorate([Struct.field(UInt64)], SaleStat.prototype, "sales", void 0);
SaleStat = __decorate([Struct.type("sale_stat")], SaleStat);
let MarketSale = class MarketSale extends Struct {};
__decorate([Struct.field(Token)], MarketSale.prototype, "symbol", void 0);
__decorate([Struct.field(SaleStat)], MarketSale.prototype, "result", void 0);
MarketSale = __decorate([Struct.type("market_sale")], MarketSale);
let MarketCollections = class MarketCollections extends Struct {};
__decorate([Struct.field(Token)], MarketCollections.prototype, "symbol", void 0);
__decorate([Struct.field(CollectionStat, { array: true })], MarketCollections.prototype, "results", void 0);
MarketCollections = __decorate([Struct.type("market_collections")], MarketCollections);
let MarketCollection = class MarketCollection extends Struct {};
__decorate([Struct.field(Token)], MarketCollection.prototype, "symbol", void 0);
__decorate([Struct.field(CollectionStat)], MarketCollection.prototype, "result", void 0);
MarketCollection = __decorate([Struct.type("market_collection")], MarketCollection);
let AccountStat = class AccountStat extends Struct {};
__decorate([Struct.field(Name)], AccountStat.prototype, "account", void 0);
__decorate([Struct.field(UInt64)], AccountStat.prototype, "buy_volume", void 0);
__decorate([Struct.field(UInt64)], AccountStat.prototype, "sell_volume", void 0);
AccountStat = __decorate([Struct.type("account_stat")], AccountStat);
let MarketAccounts = class MarketAccounts extends Struct {};
__decorate([Struct.field(Token)], MarketAccounts.prototype, "symbol", void 0);
__decorate([Struct.field(AccountStat, { array: true })], MarketAccounts.prototype, "results", void 0);
MarketAccounts = __decorate([Struct.type("market_accounts")], MarketAccounts);
let MarketAccount = class MarketAccount extends Struct {};
__decorate([Struct.field(Token)], MarketAccount.prototype, "symbol", void 0);
__decorate([Struct.field(AccountStat)], MarketAccount.prototype, "result", void 0);
MarketAccount = __decorate([Struct.type("market_account")], MarketAccount);
let SchemaStatV1 = class SchemaStatV1 extends Struct {};
__decorate([Struct.field(Name)], SchemaStatV1.prototype, "contract", void 0);
__decorate([Struct.field(Name)], SchemaStatV1.prototype, "collection_name", void 0);
__decorate([Struct.field(Name)], SchemaStatV1.prototype, "schema_name", void 0);
__decorate([Struct.field(UInt64)], SchemaStatV1.prototype, "volume", void 0);
__decorate([Struct.field(UInt64)], SchemaStatV1.prototype, "sales", void 0);
__decorate([Struct.field(UInt64, { optional: true })], SchemaStatV1.prototype, "listings", void 0);
SchemaStatV1 = __decorate([Struct.type("schema_stat_v1")], SchemaStatV1);
let SchemaStatV2 = class SchemaStatV2 extends Struct {};
__decorate([Struct.field(Name)], SchemaStatV2.prototype, "schema_name", void 0);
__decorate([Struct.field(UInt64)], SchemaStatV2.prototype, "volume", void 0);
__decorate([Struct.field(UInt64)], SchemaStatV2.prototype, "sales", void 0);
__decorate([Struct.field(UInt64, { optional: true })], SchemaStatV2.prototype, "listings", void 0);
__decorate([Struct.field(SchemaObject)], SchemaStatV2.prototype, "schema", void 0);
SchemaStatV2 = __decorate([Struct.type("schema_stat_v2")], SchemaStatV2);
let MarketSchemasV1 = class MarketSchemasV1 extends Struct {};
__decorate([Struct.field(Token)], MarketSchemasV1.prototype, "symbol", void 0);
__decorate([Struct.field(SchemaStatV1, { array: true })], MarketSchemasV1.prototype, "results", void 0);
MarketSchemasV1 = __decorate([Struct.type("market_schemas_v1")], MarketSchemasV1);
let MarketSchemasV2 = class MarketSchemasV2 extends Struct {};
__decorate([Struct.field(Token)], MarketSchemasV2.prototype, "symbol", void 0);
__decorate([Struct.field(SchemaStatV2, { array: true })], MarketSchemasV2.prototype, "results", void 0);
MarketSchemasV2 = __decorate([Struct.type("market_schemas_v2")], MarketSchemasV2);
let ActionLogsResponse$1 = class ActionLogsResponse extends ResponseStruct {};
__decorate([Struct.field(ActionLog, { array: true })], ActionLogsResponse$1.prototype, "data", void 0);
ActionLogsResponse$1 = __decorate([Struct.type("action_logs_resp")], ActionLogsResponse$1);
let GetAssetsResponse = class GetAssetsResponse extends ResponseStruct {};
__decorate([Struct.field(MarketAssetObject, { array: true })], GetAssetsResponse.prototype, "data", void 0);
GetAssetsResponse = __decorate([Struct.type("get_assets_resp")], GetAssetsResponse);
let GetAssetResponse = class GetAssetResponse extends ResponseStruct {};
__decorate([Struct.field(MarketAssetObject)], GetAssetResponse.prototype, "data", void 0);
GetAssetResponse = __decorate([Struct.type("get_asset_resp")], GetAssetResponse);
let GetAssetStatsResponse = class GetAssetStatsResponse extends ResponseStruct {};
__decorate([Struct.field(AssetStats)], GetAssetStatsResponse.prototype, "data", void 0);
GetAssetStatsResponse = __decorate([Struct.type("get_asset_stats_resp")], GetAssetStatsResponse);
let GetAssetSalesResponse = class GetAssetSalesResponse extends ResponseStruct {};
__decorate([Struct.field(AssetSale, { array: true })], GetAssetSalesResponse.prototype, "data", void 0);
GetAssetSalesResponse = __decorate([Struct.type("get_asset_sales_resp")], GetAssetSalesResponse);
let GetOffersResponse = class GetOffersResponse extends ResponseStruct {};
__decorate([Struct.field(OfferObject, { array: true })], GetOffersResponse.prototype, "data", void 0);
GetOffersResponse = __decorate([Struct.type("get_offers_resp")], GetOffersResponse);
let GetOfferResponse = class GetOfferResponse extends ResponseStruct {};
__decorate([Struct.field(OfferObject)], GetOfferResponse.prototype, "data", void 0);
GetOfferResponse = __decorate([Struct.type("get_offer_resp")], GetOfferResponse);
let GetTransfersResponse = class GetTransfersResponse extends ResponseStruct {};
__decorate([Struct.field(TransferObject, { array: true })], GetTransfersResponse.prototype, "data", void 0);
GetTransfersResponse = __decorate([Struct.type("get_transfers_resp")], GetTransfersResponse);
let GetConfigResponse$1 = class GetConfigResponse extends ResponseStruct {};
__decorate([Struct.field(AtomicMarketConfig)], GetConfigResponse$1.prototype, "data", void 0);
GetConfigResponse$1 = __decorate([Struct.type("get_config_resp")], GetConfigResponse$1);
let GetSaleResponse = class GetSaleResponse extends ResponseStruct {};
__decorate([Struct.field(SaleObject)], GetSaleResponse.prototype, "data", void 0);
GetSaleResponse = __decorate([Struct.type("get_sale_resp")], GetSaleResponse);
let GetSalesResponse = class GetSalesResponse extends ResponseStruct {};
__decorate([Struct.field(SaleObject, { array: true })], GetSalesResponse.prototype, "data", void 0);
GetSalesResponse = __decorate([Struct.type("get_sales_resp")], GetSalesResponse);
let GetSalesTemplatesResponse = class GetSalesTemplatesResponse extends ResponseStruct {};
__decorate([Struct.field(SaleObject, { array: true })], GetSalesTemplatesResponse.prototype, "data", void 0);
GetSalesTemplatesResponse = __decorate([Struct.type("get_sales_templates_resp")], GetSalesTemplatesResponse);
let GetAuctionsResponse = class GetAuctionsResponse extends ResponseStruct {};
__decorate([Struct.field(AuctionObject, { array: true })], GetAuctionsResponse.prototype, "data", void 0);
GetAuctionsResponse = __decorate([Struct.type("get_auctions_resp")], GetAuctionsResponse);
let GetAuctionResponse = class GetAuctionResponse extends ResponseStruct {};
__decorate([Struct.field(AuctionObject)], GetAuctionResponse.prototype, "data", void 0);
GetAuctionResponse = __decorate([Struct.type("get_auction_resp")], GetAuctionResponse);
let GetBuyoffersResponse = class GetBuyoffersResponse extends ResponseStruct {};
__decorate([Struct.field(BuyofferObject, { array: true })], GetBuyoffersResponse.prototype, "data", void 0);
GetBuyoffersResponse = __decorate([Struct.type("get_buyoffers_resp")], GetBuyoffersResponse);
let GetBuyofferResponse = class GetBuyofferResponse extends ResponseStruct {};
__decorate([Struct.field(BuyofferObject)], GetBuyofferResponse.prototype, "data", void 0);
GetBuyofferResponse = __decorate([Struct.type("get_buyoffer_resp")], GetBuyofferResponse);
let GetTemplateBuyoffersResponse = class GetTemplateBuyoffersResponse extends ResponseStruct {};
__decorate([Struct.field(TemplateBuyofferObject, { array: true })], GetTemplateBuyoffersResponse.prototype, "data", void 0);
GetTemplateBuyoffersResponse = __decorate([Struct.type("get_template_buyoffers_resp")], GetTemplateBuyoffersResponse);
let GetTemplateBuyofferResponse = class GetTemplateBuyofferResponse extends ResponseStruct {};
__decorate([Struct.field(TemplateBuyofferObject)], GetTemplateBuyofferResponse.prototype, "data", void 0);
GetTemplateBuyofferResponse = __decorate([Struct.type("get_template_buyoffer_resp")], GetTemplateBuyofferResponse);
let GetMarketplacesResponse = class GetMarketplacesResponse extends ResponseStruct {};
__decorate([Struct.field(Marketplace, { array: true })], GetMarketplacesResponse.prototype, "data", void 0);
GetMarketplacesResponse = __decorate([Struct.type("get_marketplaces_resp")], GetMarketplacesResponse);
let GetMarketplaceResponse = class GetMarketplaceResponse extends ResponseStruct {};
__decorate([Struct.field(Marketplace)], GetMarketplaceResponse.prototype, "data", void 0);
GetMarketplaceResponse = __decorate([Struct.type("get_marketplace_resp")], GetMarketplaceResponse);
let GetSalePricesResponse = class GetSalePricesResponse extends ResponseStruct {};
__decorate([Struct.field(SalePrice, { array: true })], GetSalePricesResponse.prototype, "data", void 0);
GetSalePricesResponse = __decorate([Struct.type("get_sale_prices_resp")], GetSalePricesResponse);
let GetSalePricesDaysResponse = class GetSalePricesDaysResponse extends ResponseStruct {};
__decorate([Struct.field(SalePriceDay, { array: true })], GetSalePricesDaysResponse.prototype, "data", void 0);
GetSalePricesDaysResponse = __decorate([Struct.type("get_sale_prices_days_resp")], GetSalePricesDaysResponse);
let GetTemplatePricesResponse = class GetTemplatePricesResponse extends ResponseStruct {};
__decorate([Struct.field(TemplatePrice, { array: true })], GetTemplatePricesResponse.prototype, "data", void 0);
GetTemplatePricesResponse = __decorate([Struct.type("get_template_prices_resp")], GetTemplatePricesResponse);
let GetAssetPricesResponse = class GetAssetPricesResponse extends ResponseStruct {};
__decorate([Struct.field(AssetPriceV1, { array: true })], GetAssetPricesResponse.prototype, "data", void 0);
GetAssetPricesResponse = __decorate([Struct.type("get_asset_prices_resp")], GetAssetPricesResponse);
let GetInventoryPricesResponse = class GetInventoryPricesResponse extends ResponseStruct {};
__decorate([Struct.field(InventoryPrice)], GetInventoryPricesResponse.prototype, "data", void 0);
GetInventoryPricesResponse = __decorate([Struct.type("get_asset_prices_resp")], GetInventoryPricesResponse);
let GetStatsCollectionsResponse = class GetStatsCollectionsResponse extends ResponseStruct {};
__decorate([Struct.field(MarketCollections)], GetStatsCollectionsResponse.prototype, "data", void 0);
GetStatsCollectionsResponse = __decorate([Struct.type("get_stats_collections_resp")], GetStatsCollectionsResponse);
let GetStatsCollectionResponse = class GetStatsCollectionResponse extends ResponseStruct {};
__decorate([Struct.field(MarketCollection)], GetStatsCollectionResponse.prototype, "data", void 0);
GetStatsCollectionResponse = __decorate([Struct.type("get_stats_collection_resp")], GetStatsCollectionResponse);
let GetStatsAccountsResponse = class GetStatsAccountsResponse extends ResponseStruct {};
__decorate([Struct.field(MarketAccounts)], GetStatsAccountsResponse.prototype, "data", void 0);
GetStatsAccountsResponse = __decorate([Struct.type("get_stats_accounts_resp")], GetStatsAccountsResponse);
let GetStatsAccountResponse = class GetStatsAccountResponse extends ResponseStruct {};
__decorate([Struct.field(MarketAccount)], GetStatsAccountResponse.prototype, "data", void 0);
GetStatsAccountResponse = __decorate([Struct.type("get_stats_account_resp")], GetStatsAccountResponse);
let GetStatsSchemasV1Response = class GetStatsSchemasV1Response extends ResponseStruct {};
__decorate([Struct.field(MarketSchemasV1)], GetStatsSchemasV1Response.prototype, "data", void 0);
GetStatsSchemasV1Response = __decorate([Struct.type("get_stats_schemas_v1_resp")], GetStatsSchemasV1Response);
let GetStatsSchemasV2Response = class GetStatsSchemasV2Response extends ResponseStruct {};
__decorate([Struct.field(MarketSchemasV2)], GetStatsSchemasV2Response.prototype, "data", void 0);
GetStatsSchemasV2Response = __decorate([Struct.type("get_stats_schemas_v2_resp")], GetStatsSchemasV2Response);
let GetStatsTemplatesResponse = class GetStatsTemplatesResponse extends ResponseStruct {};
__decorate([Struct.field(MarketTemplates)], GetStatsTemplatesResponse.prototype, "data", void 0);
GetStatsTemplatesResponse = __decorate([Struct.type("get_stats_templates_resp")], GetStatsTemplatesResponse);
let GetStatsGraphResponse = class GetStatsGraphResponse extends ResponseStruct {};
__decorate([Struct.field(MarketGraph)], GetStatsGraphResponse.prototype, "data", void 0);
GetStatsGraphResponse = __decorate([Struct.type("get_stats_graph_resp")], GetStatsGraphResponse);
let GetStatsSalesResponse = class GetStatsSalesResponse extends ResponseStruct {};
__decorate([Struct.field(MarketSale)], GetStatsSalesResponse.prototype, "data", void 0);
GetStatsSalesResponse = __decorate([Struct.type("get_stats_sales_resp")], GetStatsSalesResponse);
//#endregion
//#region src/endpoints/tools/types.ts
var types_exports$1 = __exportAll({
	ActionLogsResponse: () => ActionLogsResponse,
	GetConfigResponse: () => GetConfigResponse,
	GetLinkResponse: () => GetLinkResponse,
	GetLinksResponse: () => GetLinksResponse
});
let ActionLogsResponse = class ActionLogsResponse extends ResponseStruct {};
__decorate([Struct.field(ActionLog, { array: true })], ActionLogsResponse.prototype, "data", void 0);
ActionLogsResponse = __decorate([Struct.type("action_logs_resp")], ActionLogsResponse);
let GetLinksResponse = class GetLinksResponse extends ResponseStruct {};
__decorate([Struct.field(LinkObject, { array: true })], GetLinksResponse.prototype, "data", void 0);
GetLinksResponse = __decorate([Struct.type("get_links_resp")], GetLinksResponse);
let GetLinkResponse = class GetLinkResponse extends ResponseStruct {};
__decorate([Struct.field(LinkObject)], GetLinkResponse.prototype, "data", void 0);
GetLinkResponse = __decorate([Struct.type("get_link_resp")], GetLinkResponse);
let GetConfigResponse = class GetConfigResponse extends ResponseStruct {};
__decorate([Struct.field(AtomicToolsConfig)], GetConfigResponse.prototype, "data", void 0);
GetConfigResponse = __decorate([Struct.type("get_config_resp")], GetConfigResponse);
//#endregion
//#region src/types.ts
var types_exports = __exportAll({
	AccountBurns: () => AccountBurns,
	AccountInfo: () => AccountInfo,
	ActionLog: () => ActionLog,
	AssetObject: () => AssetObject,
	AssetPriceV1: () => AssetPriceV1,
	AssetPriceV2: () => AssetPriceV2,
	AssetSale: () => AssetSale,
	AssetStats: () => AssetStats,
	Assets: () => types_exports$3,
	AtomicAssetsConfig: () => AtomicAssetsConfig,
	AtomicMarketConfig: () => AtomicMarketConfig,
	AtomicToolsConfig: () => AtomicToolsConfig,
	AuctionBrief: () => AuctionBrief,
	AuctionObject: () => AuctionObject,
	AuctionState: () => AuctionState,
	Bid: () => Bid,
	BurnedBySchema: () => BurnedBySchema,
	BurnedByTemplate: () => BurnedByTemplate,
	BuyofferObject: () => BuyofferObject,
	BuyofferState: () => BuyofferState,
	CollectionBurn: () => CollectionBurn,
	CollectionObject: () => CollectionObject,
	CollectionPrice: () => CollectionPrice,
	CollectionStats: () => CollectionStats,
	CollectionWrapper: () => CollectionWrapper,
	CountResponseStruct: () => CountResponseStruct,
	InventoryPrice: () => InventoryPrice,
	LinkObject: () => LinkObject,
	LinkState: () => LinkState,
	Market: () => types_exports$2,
	MarketAssetObject: () => MarketAssetObject,
	Marketplace: () => Marketplace,
	OfferObject: () => OfferObject,
	OfferState: () => OfferState,
	ResponseStruct: () => ResponseStruct,
	SaleBrief: () => SaleBrief,
	SaleObject: () => SaleObject,
	SalePrice: () => SalePrice,
	SalePriceDay: () => SalePriceDay,
	SaleState: () => SaleState,
	SchemaFormatField: () => SchemaFormatField,
	SchemaObject: () => SchemaObject,
	SchemaStats: () => SchemaStats,
	SchemaWrapper: () => SchemaWrapper,
	TemplateBurn: () => TemplateBurn,
	TemplateBuyofferBrief: () => TemplateBuyofferBrief,
	TemplateBuyofferObject: () => TemplateBuyofferObject,
	TemplateBuyofferState: () => TemplateBuyofferState,
	TemplateObject: () => TemplateObject,
	TemplatePrice: () => TemplatePrice,
	TemplateStats: () => TemplateStats,
	TemplateWrapper: () => TemplateWrapper,
	Token: () => Token,
	TokenAmount: () => TokenAmount,
	Tools: () => types_exports$1,
	TradingPair: () => TradingPair,
	TransferObject: () => TransferObject
});
//#endregion
//#region src/endpoints/utils.ts
function buildBodyParams(params, extra) {
	let options = serializeQueryParams(params);
	options = fixPostArguments(options);
	return Object.assign(extra ? extra : {}, options);
}
function fixPostArguments(params) {
	const options = { ...params };
	for (const key of [
		"page",
		"limit",
		"before",
		"after",
		"burned"
	]) if (key in options) options[key] = String(options[key]);
	return options;
}
function serializeQueryParams(params) {
	const result = {};
	for (const [key, value] of Object.entries(params || {})) if (["boolean", "number"].includes(typeof value)) result[key] = value;
	else result[key] = String(value);
	return result;
}
//#endregion
//#region src/endpoints/assets/v1.ts
var AssetsV1APIClient = class {
	constructor(client) {
		this.client = client;
	}
	async get_assets(options, extra_options) {
		const bodyParams = buildBodyParams(options, extra_options);
		return this.client.call({
			path: `/atomicassets/v1/assets`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: GetAssetsResponse$1
		});
	}
	async get_assets_count(options, extra_options) {
		const bodyParams = buildBodyParams(options, extra_options);
		return this.client.call({
			path: `/atomicassets/v1/assets/_count`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: CountResponseStruct
		});
	}
	async get_asset(asset_id) {
		return this.client.call({
			path: `/atomicassets/v1/assets/${asset_id}`,
			method: "GET",
			responseType: GetAssetResponse$1
		});
	}
	async get_asset_stats(asset_id) {
		return this.client.call({
			path: `/atomicassets/v1/assets/${asset_id}/stats`,
			method: "GET",
			responseType: GetAssetStatsResponse$1
		});
	}
	async get_asset_logs(asset_id, options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicassets/v1/assets/${asset_id}/logs`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: ActionLogsResponse$2
		});
	}
	async get_collections(options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicassets/v1/collections`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: GetCollectionsResponse
		});
	}
	async get_collections_count(options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicassets/v1/collections/_count`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: CountResponseStruct
		});
	}
	async get_collection(collection_name) {
		return this.client.call({
			path: `/atomicassets/v1/collections/${collection_name}`,
			method: "GET",
			responseType: GetCollectionResponse
		});
	}
	async get_collection_stats(collection_name) {
		return this.client.call({
			path: `/atomicassets/v1/collections/${collection_name}/stats`,
			method: "GET",
			responseType: GetCollectionStatsResponse
		});
	}
	async get_collection_schemas(collection_name) {
		return this.client.call({
			path: `/atomicassets/v1/collections/${collection_name}/schemas`,
			method: "GET",
			responseType: GetCollectionSchemasResponse
		});
	}
	async get_collection_logs(collection_name, options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicassets/v1/collections/${collection_name}/logs`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: ActionLogsResponse$2
		});
	}
	async get_schemas(options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicassets/v1/schemas`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: GetSchemasResponse
		});
	}
	async get_schemas_count(options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicassets/v1/schemas/_count`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: CountResponseStruct
		});
	}
	async get_schema(collection_name, schema_name) {
		return this.client.call({
			path: `/atomicassets/v1/schemas/${collection_name}/${schema_name}`,
			method: "GET",
			responseType: GetSchemaResponse
		});
	}
	async get_schema_stats(collection_name, schema_name) {
		return this.client.call({
			path: `/atomicassets/v1/schemas/${collection_name}/${schema_name}/stats`,
			method: "GET",
			responseType: GetSchemaStatsResponse
		});
	}
	async get_schema_logs(collection_name, schema_name, options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicassets/v1/schemas/${collection_name}/${schema_name}/logs`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: ActionLogsResponse$2
		});
	}
	async get_templates(options, extra_options) {
		const bodyParams = buildBodyParams(options, extra_options);
		return this.client.call({
			path: `/atomicassets/v1/templates`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: GetTemplatesResponse
		});
	}
	async get_templates_count(options, extra_options) {
		const bodyParams = buildBodyParams(options, extra_options);
		return this.client.call({
			path: `/atomicassets/v1/templates/_count`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: CountResponseStruct
		});
	}
	async get_template(collection_name, template_id) {
		return this.client.call({
			path: `/atomicassets/v1/templates/${collection_name}/${template_id}`,
			method: "GET",
			responseType: GetTemplateResponse
		});
	}
	async get_template_stats(collection_name_or_template_id, template_id) {
		const path = typeof template_id === "undefined" ? `/atomicassets/v1/templates/${collection_name_or_template_id}/stats` : `/atomicassets/v1/templates/${collection_name_or_template_id}/${template_id}/stats`;
		return this.client.call({
			path,
			method: "GET",
			responseType: GetTemplateStatsResponse
		});
	}
	async get_template_logs(collection_name, template_id, options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicassets/v1/templates/${collection_name}/${template_id}/logs`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: ActionLogsResponse$2
		});
	}
	async get_offers(options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicassets/v1/offers`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: GetOffersResponse$1
		});
	}
	async get_offers_count(options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicassets/v1/offers/_count`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: CountResponseStruct
		});
	}
	async get_offer(offer_id) {
		return this.client.call({
			path: `/atomicassets/v1/offers/${offer_id}`,
			method: "GET",
			responseType: GetOfferResponse$1
		});
	}
	async get_offer_logs(offer_id, options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicassets/v1/offers/${offer_id}/logs`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: ActionLogsResponse$2
		});
	}
	async get_transfers(options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicassets/v1/transfers`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: GetTransfersResponse$1
		});
	}
	async get_transfers_count(options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicassets/v1/transfers/_count`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: CountResponseStruct
		});
	}
	async get_accounts(options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicassets/v1/accounts`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: GetAccountsResponse
		});
	}
	async get_accounts_count(options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicassets/v1/accounts/_count`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: CountResponseStruct
		});
	}
	async get_account(account, options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicassets/v1/accounts/${account}`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: GetAccountResponse
		});
	}
	async get_account_template_schema_count(account, collection_name) {
		return this.client.call({
			path: `/atomicassets/v1/accounts/${account}/${collection_name}`,
			method: "GET",
			responseType: GetAccountTemplateSchemaCountResponse
		});
	}
	async get_burns(options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicassets/v1/burns`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: GetAccountsResponse
		});
	}
	async get_account_burns(account, options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicassets/v1/burns/${account}`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: GetAccountBurnsResponse
		});
	}
	async get_config() {
		return this.client.call({
			path: "/atomicassets/v1/config",
			method: "GET",
			responseType: GetConfigResponse$2
		});
	}
};
//#endregion
//#region src/endpoints/assets.ts
var AssetsAPIClient = class {
	constructor(client) {
		this.client = client;
		this.v1 = new AssetsV1APIClient(client);
	}
};
//#endregion
//#region src/endpoints/market/v1.ts
var MarketV1APIClient = class {
	constructor(client) {
		this.client = client;
	}
	async get_assets(options, extra_options) {
		const bodyParams = buildBodyParams(options, extra_options);
		return this.client.call({
			path: `/atomicmarket/v1/assets`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: GetAssetsResponse
		});
	}
	async get_assets_count(options, extra_options) {
		const bodyParams = buildBodyParams(options, extra_options);
		return this.client.call({
			path: `/atomicmarket/v1/assets/_count`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: CountResponseStruct
		});
	}
	async get_asset(asset_id) {
		return this.client.call({
			path: `/atomicmarket/v1/assets/${asset_id}`,
			method: "GET",
			responseType: GetAssetResponse
		});
	}
	async get_asset_stats(asset_id) {
		return this.client.call({
			path: `/atomicmarket/v1/assets/${asset_id}/stats`,
			method: "GET",
			responseType: GetAssetStatsResponse
		});
	}
	async get_asset_logs(asset_id, options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicmarket/v1/assets/${asset_id}/logs`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: ActionLogsResponse$1
		});
	}
	async get_asset_sales(asset_id, options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicmarket/v1/assets/${asset_id}/sales`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: GetAssetSalesResponse
		});
	}
	async get_offers(options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicmarket/v1/offers`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: GetOffersResponse
		});
	}
	async get_offer(offer_id) {
		return this.client.call({
			path: `/atomicmarket/v1/offers/${offer_id}`,
			method: "GET",
			responseType: GetOfferResponse
		});
	}
	async get_offer_logs(offer_id, options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicmarket/v1/offers/${offer_id}/logs`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: ActionLogsResponse$1
		});
	}
	async get_transfers(options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicmarket/v1/transfers`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: GetTransfersResponse
		});
	}
	async get_sale(sale_id) {
		return this.client.call({
			path: `/atomicmarket/v1/sales/${sale_id}`,
			method: "GET",
			responseType: GetSaleResponse
		});
	}
	async get_sale_logs(sale_id, options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicmarket/v1/sales/${sale_id}/logs`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: ActionLogsResponse$1
		});
	}
	async get_sales_by_templates(options, extra_options) {
		const bodyParams = buildBodyParams(options, extra_options);
		return this.client.call({
			path: `/atomicmarket/v1/sales/templates`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: GetSalesTemplatesResponse
		});
	}
	async get_auctions(options, extra_options) {
		const bodyParams = buildBodyParams(options, extra_options);
		return this.client.call({
			path: `/atomicmarket/v1/auctions`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: GetAuctionsResponse
		});
	}
	async get_auctions_count(options, extra_options) {
		const bodyParams = buildBodyParams(options, extra_options);
		return this.client.call({
			path: `/atomicmarket/v1/auctions/_count`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: CountResponseStruct
		});
	}
	async get_auction(auction_id) {
		return this.client.call({
			path: `/atomicmarket/v1/auctions/${auction_id}`,
			method: "GET",
			responseType: GetAuctionResponse
		});
	}
	async get_auction_logs(auction_id, options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicmarket/v1/auctions/${auction_id}/logs`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: ActionLogsResponse$1
		});
	}
	async get_buyoffers(options, extra_options) {
		const bodyParams = buildBodyParams(options, extra_options);
		return this.client.call({
			path: `/atomicmarket/v1/buyoffers`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: GetBuyoffersResponse
		});
	}
	async get_buyoffers_count(options, extra_options) {
		const bodyParams = buildBodyParams(options, extra_options);
		return this.client.call({
			path: `/atomicmarket/v1/buyoffers/_count`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: CountResponseStruct
		});
	}
	async get_buyoffer(buyoffer_id) {
		return this.client.call({
			path: `/atomicmarket/v1/buyoffers/${buyoffer_id}`,
			method: "GET",
			responseType: GetBuyofferResponse
		});
	}
	async get_buyoffer_logs(buyoffer_id, options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicmarket/v1/buyoffers/${buyoffer_id}/logs`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: ActionLogsResponse$1
		});
	}
	async get_template_buyoffers(options, extra_options) {
		const bodyParams = buildBodyParams(options, extra_options);
		return this.client.call({
			path: `/atomicmarket/v1/template_buyoffers`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: GetTemplateBuyoffersResponse
		});
	}
	async get_template_buyoffers_count(options, extra_options) {
		const bodyParams = buildBodyParams(options, extra_options);
		return this.client.call({
			path: `/atomicmarket/v1/template_buyoffers/_count`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: CountResponseStruct
		});
	}
	async get_template_buyoffer(buyoffer_id) {
		return this.client.call({
			path: `/atomicmarket/v1/template_buyoffers/${buyoffer_id}`,
			method: "GET",
			responseType: GetTemplateBuyofferResponse
		});
	}
	async get_template_buyoffer_logs(buyoffer_id, options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicmarket/v1/template_buyoffers/${buyoffer_id}/logs`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: ActionLogsResponse$1
		});
	}
	async get_marketplaces() {
		return this.client.call({
			path: `/atomicmarket/v1/marketplaces`,
			method: "GET",
			responseType: GetMarketplacesResponse
		});
	}
	async get_marketplace(marketplace_name) {
		return this.client.call({
			path: `/atomicmarket/v1/marketplaces/${marketplace_name}`,
			method: "GET",
			responseType: GetMarketplaceResponse
		});
	}
	async get_sale_prices(options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicmarket/v1/prices/sales`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: GetSalePricesResponse
		});
	}
	async get_sale_prices_by_days(options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicmarket/v1/prices/sales/days`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: GetSalePricesDaysResponse
		});
	}
	async get_template_prices(options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicmarket/v1/prices/templates`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: GetTemplatePricesResponse
		});
	}
	async get_asset_prices(options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicmarket/v1/prices/assets`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: GetAssetPricesResponse
		});
	}
	async get_inventory_prices(account, options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicmarket/v1/prices/inventory/${account}`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: GetInventoryPricesResponse
		});
	}
	async get_stats_collections(options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicmarket/v1/stats/collections`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: GetStatsCollectionsResponse
		});
	}
	async get_stats_collection(collection_name, options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicmarket/v1/stats/collections/${collection_name}`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: GetStatsCollectionResponse
		});
	}
	async get_stats_accounts(options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicmarket/v1/stats/accounts`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: GetStatsAccountsResponse
		});
	}
	async get_stats_account(account, options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicmarket/v1/stats/accounts/${account}`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: GetStatsAccountResponse
		});
	}
	async get_stats_schemas(collection_name, options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicmarket/v1/stats/schemas/${collection_name}`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: GetStatsSchemasV1Response
		});
	}
	async get_stats_templates(options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicmarket/v1/stats/templates`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: GetStatsTemplatesResponse
		});
	}
	async get_stats_graph(options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicmarket/v1/stats/graph`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: GetStatsGraphResponse
		});
	}
	async get_stats_sales(options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicmarket/v1/stats/sales`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: GetStatsSalesResponse
		});
	}
	async get_config() {
		return this.client.call({
			path: "/atomicmarket/v1/config",
			method: "GET",
			responseType: GetConfigResponse$1
		});
	}
};
//#endregion
//#region src/endpoints/market/v2.ts
var MarketV2APIClient = class {
	constructor(client) {
		this.client = client;
	}
	async get_sales(options, extra_options) {
		const bodyParams = buildBodyParams(options, extra_options);
		return this.client.call({
			path: `/atomicmarket/v2/sales`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: GetSalesResponse
		});
	}
	async get_sales_count(options, extra_options) {
		const bodyParams = buildBodyParams(options, extra_options);
		return this.client.call({
			path: `/atomicmarket/v2/sales/_count`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: CountResponseStruct
		});
	}
	async get_stats_schemas(collection_name, options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomicmarket/v2/stats/schemas/${collection_name}`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: GetStatsSchemasV2Response
		});
	}
};
//#endregion
//#region src/endpoints/market.ts
var MarketAPIClient = class {
	constructor(client) {
		this.client = client;
		this.v1 = new MarketV1APIClient(client);
		this.v2 = new MarketV2APIClient(client);
	}
};
//#endregion
//#region src/endpoints/tools/v1.ts
var ToolsV1APIClient = class {
	constructor(client) {
		this.client = client;
	}
	async get_links(options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomictools/v1/links`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: GetLinksResponse
		});
	}
	async get_links_count(options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomictools/v1/links/_count`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: CountResponseStruct
		});
	}
	async get_link(link_id) {
		return this.client.call({
			path: `/atomictools/v1/links/${link_id}`,
			method: "GET",
			responseType: GetLinkResponse
		});
	}
	async get_link_logs(link_id, options) {
		const bodyParams = buildBodyParams(options);
		return this.client.call({
			path: `/atomictools/v1/links/${link_id}/logs`,
			method: "POST",
			params: bodyParams,
			headers: { "Content-Type": "application/json" },
			responseType: ActionLogsResponse
		});
	}
	async get_config() {
		return this.client.call({
			path: "/atomictools/v1/config",
			method: "GET",
			responseType: GetConfigResponse
		});
	}
};
//#endregion
//#region src/endpoints/tools.ts
var ToolsAPIClient = class {
	constructor(client) {
		this.client = client;
		this.v1 = new ToolsV1APIClient(client);
	}
};
//#endregion
//#region src/endpoints.ts
var AtomicAssetsAPIClient = class {
	constructor(client) {
		this.client = client;
		this.atomicassets = new AssetsAPIClient(client);
		this.atomicmarket = new MarketAPIClient(client);
		this.atomictools = new ToolsAPIClient(client);
	}
};
//#endregion
//#region src/objects/collection.ts
var Collection = class {
	static from(collectionObject, utility) {
		return new this(utility, collectionObject);
	}
	constructor(utility, data) {
		this.utility = utility;
		this.data = data;
	}
	get collectionName() {
		return Name.from(this.data.collection_name);
	}
	get author() {
		return Name.from(this.data.author);
	}
	get allowNotify() {
		return this.data.allow_notify;
	}
	get authorizedAccounts() {
		return this.data.authorized_accounts.map((a) => Name.from(a));
	}
	get notifyAccounts() {
		return this.data.notify_accounts.map((a) => Name.from(a));
	}
	get marketFee() {
		return Float64.from(this.data.market_fee);
	}
	get collectionData() {
		return this.data.data;
	}
	get name() {
		return this.data.name;
	}
	get image() {
		return this.data.img;
	}
	addAuth(account) {
		return this.utility.assetsContract.action("addcolauth", {
			collection_name: this.collectionName,
			account_to_add: account
		});
	}
	removeAuth(account) {
		return this.utility.assetsContract.action("remcolauth", {
			collection_name: this.collectionName,
			account_to_remove: account
		});
	}
	setData(data) {
		return this.utility.assetsContract.action("setcoldata", {
			collection_name: this.collectionName,
			data
		});
	}
	addNotifyAccount(account) {
		return this.utility.assetsContract.action("addnotifyacc", {
			collection_name: this.collectionName,
			account_to_add: account
		});
	}
	removeNotifyAccount(account) {
		return this.utility.assetsContract.action("remnotifyacc", {
			collection_name: this.collectionName,
			account_to_remove: account
		});
	}
	setMarketFee(fee) {
		return this.utility.assetsContract.action("setmarketfee", {
			collection_name: this.collectionName,
			market_fee: fee
		});
	}
	forbidnotify() {
		return this.utility.assetsContract.action("forbidnotify", { collection_name: this.collectionName });
	}
};
//#endregion
//#region src/objects/schema.ts
var Schema = class {
	static from(schemaObject, utility) {
		const collection = new Collection(utility, schemaObject.collection);
		return new this(utility, schemaObject, collection);
	}
	constructor(utility, data, collection) {
		this.utility = utility;
		this.data = data;
		this.collection = collection;
	}
	get schemaName() {
		return Name.from(this.data.schema_name);
	}
	get assets() {
		return UInt64.from(this.data.assets);
	}
	get format() {
		return this.data.format;
	}
	extendSchema(authorizedEditor, schemaFormat) {
		return this.utility.assetsContract.action("extendschema", {
			authorized_editor: authorizedEditor,
			collection_name: this.collection.collectionName,
			schema_name: this.schemaName,
			schema_format_extension: schemaFormat
		});
	}
};
//#endregion
//#region src/objects/template.ts
var Template = class {
	static from(templateObject, utility) {
		const collection = new Collection(utility, templateObject.collection);
		const schema = new Schema(utility, templateObject.schema, collection);
		return new this(utility, templateObject, collection, schema);
	}
	constructor(utility, data, collection, schema) {
		this.utility = utility;
		this.data = data;
		this.collection = collection;
		this.schema = schema;
	}
	get templateId() {
		return Int32.from(this.data.template_id);
	}
	get transferable() {
		return this.data.is_transferable;
	}
	get burnable() {
		return this.data.is_burnable;
	}
	get issuedSupply() {
		return UInt32.from(this.data.issued_supply);
	}
	get maxSupply() {
		return UInt32.from(this.data.max_supply);
	}
	get immutableData() {
		return this.data.immutable_data;
	}
	lock(authorizedEditor) {
		return this.utility.assetsContract.action("locktemplate", {
			authorized_editor: authorizedEditor,
			collection_name: this.collection.collectionName,
			template_id: this.templateId
		});
	}
};
//#endregion
//#region src/objects/asset.ts
var Asset = class {
	static from(assetObject, utility) {
		const collection = new Collection(utility, assetObject.collection);
		const schema = new Schema(utility, assetObject.schema, collection);
		const template = new Template(utility, assetObject.template, collection, schema);
		return new this(utility, assetObject, collection, schema, template);
	}
	constructor(utility, data, collection, schema, template) {
		this.utility = utility;
		this.data = data;
		this.collection = collection;
		this.schema = schema;
		this.template = template;
		this.backedTokens = this.data.backed_tokens.map((t) => ExtendedAsset.from({
			quantity: Asset$1.fromUnits(t.amount, Asset$1.Symbol.from(`${t.token_precision},${t.token_symbol}`)),
			contract: t.token_contract
		}));
	}
	get assetId() {
		return UInt64.from(this.data.asset_id);
	}
	get immutableData() {
		return this.data.immutable_data;
	}
	get mutableData() {
		return this.data.mutable_data;
	}
	get assetData() {
		return this.data.data;
	}
	get owner() {
		return this.data.owner ? Name.from(this.data.owner) : null;
	}
	get transferable() {
		return this.data.is_transferable;
	}
	get burnable() {
		return this.data.is_burnable;
	}
	get name() {
		return this.data.name;
	}
	get burnedByAccount() {
		return this.data.burned_by_account ? Name.from(this.data.burned_by_account) : null;
	}
	burn() {
		return this.utility.assetsContract.action("burnasset", {
			asset_owner: this.owner,
			asset_id: this.assetId
		});
	}
	back(payer, backedToken) {
		return this.utility.assetsContract.action("backasset", {
			payer,
			asset_owner: this.owner,
			asset_id: this.assetId,
			token_to_back: backedToken
		});
	}
	setData(authorizedEditor, mutableData) {
		return this.utility.assetsContract.action("setassetdata", {
			authorized_editor: authorizedEditor,
			asset_owner: this.owner,
			asset_id: this.assetId,
			new_mutable_data: mutableData
		});
	}
};
//#endregion
//#region src/objects/offer.ts
var Offer = class {
	static from(offerObject, utility) {
		const sender_assets = [];
		const recipient_assets = [];
		for (const item of [{
			ass: sender_assets,
			objs: offerObject.sender_assets
		}, {
			ass: recipient_assets,
			objs: offerObject.recipient_assets
		}]) for (const assetObject of item.objs) item.ass.push(Asset.from(assetObject, utility));
		return new this(utility, offerObject, sender_assets, recipient_assets);
	}
	constructor(utility, data, sender_assets, recipient_assets) {
		this.utility = utility;
		this.data = data;
		this.sender_assets = sender_assets;
		this.recipient_assets = recipient_assets;
	}
	get offerId() {
		return this.data.offer_id;
	}
	get senderName() {
		return Name.from(this.data.sender_name);
	}
	get recipientName() {
		return Name.from(this.data.recipient_name);
	}
	get memo() {
		return this.data.memo;
	}
	get state() {
		return OfferState[OfferState[this.data.state.toNumber()]];
	}
	get isSenderContract() {
		return this.data.is_sender_contract;
	}
	get isRecipientContract() {
		return this.data.is_recipient_contract;
	}
	cancel() {
		return this.utility.assetsContract.action("canceloffer", { offer_id: this.offerId });
	}
	decline() {
		return this.utility.assetsContract.action("declineoffer", { offer_id: this.offerId });
	}
	accept() {
		return this.utility.assetsContract.action("acceptoffer", { offer_id: this.offerId });
	}
	payram(payer) {
		return this.utility.assetsContract.action("payofferram", {
			payer,
			offer_id: this.offerId
		});
	}
};
//#endregion
//#region src/objects/auction.ts
var Auction = class {
	static from(auctionObject, utility) {
		const collection = new Collection(utility, auctionObject.collection);
		const assets = auctionObject.assets.map((a) => Asset.from(a, utility));
		return new this(utility, auctionObject, collection, assets);
	}
	constructor(utility, data, collection, assets) {
		this.utility = utility;
		this.data = data;
		this.collection = collection;
		this.assets = assets;
		this.price = ExtendedAsset.from({
			quantity: Asset$1.fromUnits(this.data.price.amount, Asset$1.Symbol.from(`${this.data.price.token_precision},${this.data.price.token_symbol}`)),
			contract: this.data.price.token_contract
		});
	}
	get auctionId() {
		return UInt64.from(this.data.auction_id);
	}
	get seller() {
		return Name.from(this.data.seller);
	}
	get buyer() {
		return this.data.buyer ? Name.from(this.data.buyer) : null;
	}
	get endTime() {
		return this.data.end_time;
	}
	get bids() {
		return this.data.bids;
	}
	get state() {
		return AuctionState[AuctionState[this.data.state.toNumber()]];
	}
	get claimedBySeller() {
		return this.data.claimed_by_seller;
	}
	get claimedByBuyer() {
		return this.data.claimed_by_buyer;
	}
	get makerMarketplace() {
		return Name.from(this.data.maker_marketplace ?? "");
	}
	get takerMarketplace() {
		return this.data.taker_marketplace ? Name.from(this.data.taker_marketplace) : null;
	}
	get isSellerContract() {
		return this.data.is_seller_contract;
	}
	assert() {
		return this.utility.marketContract.action("assertauct", {
			auction_id: this.auctionId,
			asset_ids_to_assert: this.assets.map((a) => a.assetId)
		});
	}
	claimBuy() {
		return this.utility.marketContract.action("auctclaimbuy", { auction_id: this.auctionId });
	}
	claimSell() {
		return this.utility.marketContract.action("auctclaimsel", { auction_id: this.auctionId });
	}
	bid(bidder, bid, takerMarketplace) {
		return this.utility.marketContract.action("auctionbid", {
			bidder,
			auction_id: this.auctionId,
			bid,
			taker_marketplace: takerMarketplace
		});
	}
	cancel() {
		return this.utility.marketContract.action("cancelauct", { auction_id: this.auctionId });
	}
	payram(payer) {
		return this.utility.marketContract.action("payauctram", {
			payer,
			auction_id: this.auctionId
		});
	}
};
//#endregion
//#region src/objects/buyoffer.ts
var Buyoffer = class {
	static from(buyofferObject, utility) {
		const collection = new Collection(utility, buyofferObject.collection);
		const assets = buyofferObject.assets.map((a) => Asset.from(a, utility));
		return new this(utility, buyofferObject, collection, assets);
	}
	constructor(utility, data, collection, assets) {
		this.utility = utility;
		this.data = data;
		this.collection = collection;
		this.assets = assets;
		this.price = ExtendedAsset.from({
			quantity: Asset$1.fromUnits(this.data.price.amount, Asset$1.Symbol.from(`${this.data.price.token_precision},${this.data.price.token_symbol}`)),
			contract: this.data.price.token_contract
		});
	}
	get buyofferId() {
		return UInt64.from(this.data.buyoffer_id);
	}
	get seller() {
		return this.data.seller ? Name.from(this.data.seller) : null;
	}
	get buyer() {
		return Name.from(this.data.buyer);
	}
	get makerMarketplace() {
		return Name.from(this.data.maker_marketplace ?? "");
	}
	get takerMarketplace() {
		return this.data.taker_marketplace ? Name.from(this.data.taker_marketplace) : null;
	}
	get memo() {
		return this.data.memo;
	}
	get declineMemo() {
		return this.data.decline_memo;
	}
	get state() {
		return BuyofferState[BuyofferState[this.data.state.toNumber()]];
	}
	accept(takerMarketplace) {
		return this.utility.marketContract.action("acceptbuyo", {
			buyoffer_id: this.buyofferId,
			expected_asset_ids: this.assets.map((a) => a.assetId),
			expected_price: this.price.quantity,
			taker_marketplace: takerMarketplace
		});
	}
	cancel() {
		return this.utility.marketContract.action("cancelbuyo", { buyoffer_id: this.buyofferId });
	}
	decline(memo) {
		return this.utility.marketContract.action("declinebuyo", {
			buyoffer_id: this.buyofferId,
			decline_memo: memo
		});
	}
	payram(payer) {
		return this.utility.marketContract.action("paybuyoram", {
			payer,
			buyoffer_id: this.buyofferId
		});
	}
};
//#endregion
//#region src/objects/link.ts
var Link = class {
	static from(linkObject, utility) {
		const assets = linkObject.assets.map((a) => Asset.from(a, utility));
		return new this(utility, linkObject, assets);
	}
	constructor(utility, data, assets) {
		this.utility = utility;
		this.data = data;
		this.assets = assets;
		this.publicKey = PublicKey.from(this.data.public_key);
	}
	get linkId() {
		return UInt64.from(this.data.link_id);
	}
	get creator() {
		return Name.from(this.data.creator);
	}
	get claimer() {
		return this.data.claimer ? Name.from(this.data.claimer) : null;
	}
	get state() {
		return LinkState[LinkState[this.data.state.toNumber()]];
	}
	get memo() {
		return this.data.memo;
	}
	cancel() {
		return this.utility.toolsContract.action("cancellink", { link_id: this.linkId });
	}
	claim(claimer, claimerSignature) {
		return this.utility.toolsContract.action("claimlink", {
			link_id: this.linkId,
			claimer,
			claimer_signature: claimerSignature
		});
	}
};
//#endregion
//#region src/objects/sale.ts
var Sale = class {
	static from(saleObject, utility) {
		const collection = new Collection(utility, saleObject.collection);
		const assets = saleObject.assets.map((a) => Asset.from(a, utility));
		return new this(utility, saleObject, collection, assets);
	}
	constructor(utility, data, collection, assets) {
		this.utility = utility;
		this.data = data;
		this.collection = collection;
		this.assets = assets;
		this.price = ExtendedAsset.from({
			quantity: Asset$1.fromUnits(this.data.price.amount, Asset$1.Symbol.from(`${this.data.price.token_precision},${this.data.price.token_symbol}`)),
			contract: this.data.price.token_contract
		});
	}
	get saleId() {
		return UInt64.from(this.data.sale_id);
	}
	get seller() {
		return Name.from(this.data.seller);
	}
	get buyer() {
		return this.data.buyer ? Name.from(this.data.buyer) : null;
	}
	get listingPrice() {
		return Asset$1.fromUnits(this.data.listing_price, this.listingSymbol);
	}
	get listingSymbol() {
		return this.price.quantity.symbol;
	}
	get makerMarketplace() {
		return Name.from(this.data.maker_marketplace ?? "");
	}
	get takerMarketplace() {
		return this.data.taker_marketplace ? Name.from(this.data.taker_marketplace) : null;
	}
	get state() {
		return SaleState[SaleState[this.data.state.toNumber()]];
	}
	get isSellerContract() {
		return this.data.is_seller_contract;
	}
	assert() {
		return this.utility.marketContract.action("assertsale", {
			sale_id: this.saleId,
			asset_ids_to_assert: this.assets.map((a) => a.assetId),
			listing_price_to_assert: this.listingPrice,
			settlement_symbol_to_assert: this.listingSymbol
		});
	}
	cancel() {
		return this.utility.marketContract.action("cancelsale", { sale_id: this.saleId });
	}
	payram(payer) {
		return this.utility.marketContract.action("paysaleram", {
			payer,
			sale_id: this.saleId
		});
	}
	purchase(buyer, intendedDelphiMedian, takerMarketplace) {
		return this.utility.marketContract.action("purchasesale", {
			buyer,
			sale_id: this.saleId,
			intended_delphi_median: intendedDelphiMedian,
			taker_marketplace: takerMarketplace
		});
	}
};
//#endregion
//#region src/contracts/atomicmarket.ts
var atomicmarket_exports = __exportAll({
	Contract: () => Contract$2,
	TableMap: () => TableMap$1,
	Types: () => Types$1,
	abi: () => abi$1,
	abiBlob: () => abiBlob$1
});
const abiBlob$1 = Blob.from("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");
const abi$1 = ABI.from(abiBlob$1);
var Contract$2 = class extends Contract {
	constructor(args) {
		super({
			client: args.client,
			abi: abi$1,
			account: args.account || Name.from("atomicmarket")
		});
	}
	action(name, data, options) {
		return super.action(name, data, options);
	}
	table(name, scope) {
		return super.table(name, scope, TableMap$1[name]);
	}
};
let Types$1;
(function(_Types) {
	let variant_int8_int16_int32_int64_uint8_uint16_uint32_uint64_float32_float64_string_INT8_VEC_INT16_VEC_INT32_VEC_INT64_VEC_UINT8_VEC_UINT16_VEC_UINT32_VEC_UINT64_VEC_FLOAT_VEC_DOUBLE_VEC_STRING_VEC = class variant_int8_int16_int32_int64_uint8_uint16_uint32_uint64_float32_float64_string_INT8_VEC_INT16_VEC_INT32_VEC_INT64_VEC_UINT8_VEC_UINT16_VEC_UINT32_VEC_UINT64_VEC_FLOAT_VEC_DOUBLE_VEC_STRING_VEC extends Variant {};
	variant_int8_int16_int32_int64_uint8_uint16_uint32_uint64_float32_float64_string_INT8_VEC_INT16_VEC_INT32_VEC_INT64_VEC_UINT8_VEC_UINT16_VEC_UINT32_VEC_UINT64_VEC_FLOAT_VEC_DOUBLE_VEC_STRING_VEC = __decorate([Variant.type("variant_int8_int16_int32_int64_uint8_uint16_uint32_uint64_float32_float64_string_INT8_VEC_INT16_VEC_INT32_VEC_INT64_VEC_UINT8_VEC_UINT16_VEC_UINT32_VEC_UINT64_VEC_FLOAT_VEC_DOUBLE_VEC_STRING_VEC", [
		Int8,
		Int16,
		Int32,
		Int64,
		UInt8,
		UInt16,
		UInt32,
		UInt64,
		Float32,
		Float64,
		"string",
		Bytes,
		{
			type: Int16,
			array: true
		},
		{
			type: Int32,
			array: true
		},
		{
			type: Int64,
			array: true
		},
		{
			type: UInt8,
			array: true
		},
		{
			type: UInt16,
			array: true
		},
		{
			type: UInt32,
			array: true
		},
		{
			type: UInt64,
			array: true
		},
		{
			type: Float32,
			array: true
		},
		{
			type: Float64,
			array: true
		},
		"string[]"
	])], variant_int8_int16_int32_int64_uint8_uint16_uint32_uint64_float32_float64_string_INT8_VEC_INT16_VEC_INT32_VEC_INT64_VEC_UINT8_VEC_UINT16_VEC_UINT32_VEC_UINT64_VEC_FLOAT_VEC_DOUBLE_VEC_STRING_VEC);
	_Types.variant_int8_int16_int32_int64_uint8_uint16_uint32_uint64_float32_float64_string_INT8_VEC_INT16_VEC_INT32_VEC_INT64_VEC_UINT8_VEC_UINT16_VEC_UINT32_VEC_UINT64_VEC_FLOAT_VEC_DOUBLE_VEC_STRING_VEC = variant_int8_int16_int32_int64_uint8_uint16_uint32_uint64_float32_float64_string_INT8_VEC_INT16_VEC_INT32_VEC_INT64_VEC_UINT8_VEC_UINT16_VEC_UINT32_VEC_UINT64_VEC_FLOAT_VEC_DOUBLE_VEC_STRING_VEC;
	let COUNTER_RANGE = class COUNTER_RANGE extends Struct {};
	__decorate([Struct.field(Name)], COUNTER_RANGE.prototype, "counter_name", void 0);
	__decorate([Struct.field(UInt64)], COUNTER_RANGE.prototype, "start_id", void 0);
	__decorate([Struct.field(UInt64)], COUNTER_RANGE.prototype, "end_id", void 0);
	COUNTER_RANGE = __decorate([Struct.type("COUNTER_RANGE")], COUNTER_RANGE);
	_Types.COUNTER_RANGE = COUNTER_RANGE;
	let ROYALTYPAIR = class ROYALTYPAIR extends Struct {};
	__decorate([Struct.field(Name)], ROYALTYPAIR.prototype, "recipient", void 0);
	__decorate([Struct.field(UInt32)], ROYALTYPAIR.prototype, "weight", void 0);
	ROYALTYPAIR = __decorate([Struct.type("ROYALTYPAIR")], ROYALTYPAIR);
	_Types.ROYALTYPAIR = ROYALTYPAIR;
	let ROYALTYPAYOUT = class ROYALTYPAYOUT extends Struct {};
	__decorate([Struct.field(Name)], ROYALTYPAYOUT.prototype, "recipient", void 0);
	__decorate([Struct.field(Asset$1)], ROYALTYPAYOUT.prototype, "amount", void 0);
	ROYALTYPAYOUT = __decorate([Struct.type("ROYALTYPAYOUT")], ROYALTYPAYOUT);
	_Types.ROYALTYPAYOUT = ROYALTYPAYOUT;
	let SYMBOLPAIR = class SYMBOLPAIR extends Struct {};
	__decorate([Struct.field(Asset$1.Symbol)], SYMBOLPAIR.prototype, "listing_symbol", void 0);
	__decorate([Struct.field(Asset$1.Symbol)], SYMBOLPAIR.prototype, "settlement_symbol", void 0);
	__decorate([Struct.field(Name)], SYMBOLPAIR.prototype, "delphi_pair_name", void 0);
	__decorate([Struct.field("bool")], SYMBOLPAIR.prototype, "invert_delphi_pair", void 0);
	SYMBOLPAIR = __decorate([Struct.type("SYMBOLPAIR")], SYMBOLPAIR);
	_Types.SYMBOLPAIR = SYMBOLPAIR;
	let TOKEN = class TOKEN extends Struct {};
	__decorate([Struct.field(Name)], TOKEN.prototype, "token_contract", void 0);
	__decorate([Struct.field(Asset$1.Symbol)], TOKEN.prototype, "token_symbol", void 0);
	TOKEN = __decorate([Struct.type("TOKEN")], TOKEN);
	_Types.TOKEN = TOKEN;
	let acceptbuyo = class acceptbuyo extends Struct {};
	__decorate([Struct.field(UInt64)], acceptbuyo.prototype, "buyoffer_id", void 0);
	__decorate([Struct.field(UInt64, { array: true })], acceptbuyo.prototype, "expected_asset_ids", void 0);
	__decorate([Struct.field(Asset$1)], acceptbuyo.prototype, "expected_price", void 0);
	__decorate([Struct.field(Name)], acceptbuyo.prototype, "taker_marketplace", void 0);
	acceptbuyo = __decorate([Struct.type("acceptbuyo")], acceptbuyo);
	_Types.acceptbuyo = acceptbuyo;
	let addafeectr = class addafeectr extends Struct {};
	__decorate([Struct.field(UInt64)], addafeectr.prototype, "bonusfee_id", void 0);
	__decorate([Struct.field(Name)], addafeectr.prototype, "counter_name_to_add", void 0);
	addafeectr = __decorate([Struct.type("addafeectr")], addafeectr);
	_Types.addafeectr = addafeectr;
	let addbonusfee = class addbonusfee extends Struct {};
	__decorate([Struct.field(Name)], addbonusfee.prototype, "fee_recipient", void 0);
	__decorate([Struct.field(Float64)], addbonusfee.prototype, "fee", void 0);
	__decorate([Struct.field(Name, { array: true })], addbonusfee.prototype, "applicable_counter_names", void 0);
	__decorate([Struct.field("string")], addbonusfee.prototype, "fee_name", void 0);
	addbonusfee = __decorate([Struct.type("addbonusfee")], addbonusfee);
	_Types.addbonusfee = addbonusfee;
	let addconftoken = class addconftoken extends Struct {};
	__decorate([Struct.field(Name)], addconftoken.prototype, "token_contract", void 0);
	__decorate([Struct.field(Asset$1.Symbol)], addconftoken.prototype, "token_symbol", void 0);
	addconftoken = __decorate([Struct.type("addconftoken")], addconftoken);
	_Types.addconftoken = addconftoken;
	let adddelphi = class adddelphi extends Struct {};
	__decorate([Struct.field(Name)], adddelphi.prototype, "delphi_pair_name", void 0);
	__decorate([Struct.field("bool")], adddelphi.prototype, "invert_delphi_pair", void 0);
	__decorate([Struct.field(Asset$1.Symbol)], adddelphi.prototype, "listing_symbol", void 0);
	__decorate([Struct.field(Asset$1.Symbol)], adddelphi.prototype, "settlement_symbol", void 0);
	adddelphi = __decorate([Struct.type("adddelphi")], adddelphi);
	_Types.adddelphi = adddelphi;
	let announceauct = class announceauct extends Struct {};
	__decorate([Struct.field(Name)], announceauct.prototype, "seller", void 0);
	__decorate([Struct.field(UInt64, { array: true })], announceauct.prototype, "asset_ids", void 0);
	__decorate([Struct.field(Asset$1)], announceauct.prototype, "starting_bid", void 0);
	__decorate([Struct.field(UInt32)], announceauct.prototype, "duration", void 0);
	__decorate([Struct.field(Name)], announceauct.prototype, "maker_marketplace", void 0);
	announceauct = __decorate([Struct.type("announceauct")], announceauct);
	_Types.announceauct = announceauct;
	let announcesale = class announcesale extends Struct {};
	__decorate([Struct.field(Name)], announcesale.prototype, "seller", void 0);
	__decorate([Struct.field(UInt64, { array: true })], announcesale.prototype, "asset_ids", void 0);
	__decorate([Struct.field(Asset$1)], announcesale.prototype, "listing_price", void 0);
	__decorate([Struct.field(Asset$1.Symbol)], announcesale.prototype, "settlement_symbol", void 0);
	__decorate([Struct.field(Name)], announcesale.prototype, "maker_marketplace", void 0);
	announcesale = __decorate([Struct.type("announcesale")], announcesale);
	_Types.announcesale = announcesale;
	let assertauct = class assertauct extends Struct {};
	__decorate([Struct.field(UInt64)], assertauct.prototype, "auction_id", void 0);
	__decorate([Struct.field(UInt64, { array: true })], assertauct.prototype, "asset_ids_to_assert", void 0);
	assertauct = __decorate([Struct.type("assertauct")], assertauct);
	_Types.assertauct = assertauct;
	let assertsale = class assertsale extends Struct {};
	__decorate([Struct.field(UInt64)], assertsale.prototype, "sale_id", void 0);
	__decorate([Struct.field(UInt64, { array: true })], assertsale.prototype, "asset_ids_to_assert", void 0);
	__decorate([Struct.field(Asset$1)], assertsale.prototype, "listing_price_to_assert", void 0);
	__decorate([Struct.field(Asset$1.Symbol)], assertsale.prototype, "settlement_symbol_to_assert", void 0);
	assertsale = __decorate([Struct.type("assertsale")], assertsale);
	_Types.assertsale = assertsale;
	let auctclaimbuy = class auctclaimbuy extends Struct {};
	__decorate([Struct.field(UInt64)], auctclaimbuy.prototype, "auction_id", void 0);
	auctclaimbuy = __decorate([Struct.type("auctclaimbuy")], auctclaimbuy);
	_Types.auctclaimbuy = auctclaimbuy;
	let auctclaimsel = class auctclaimsel extends Struct {};
	__decorate([Struct.field(UInt64)], auctclaimsel.prototype, "auction_id", void 0);
	auctclaimsel = __decorate([Struct.type("auctclaimsel")], auctclaimsel);
	_Types.auctclaimsel = auctclaimsel;
	let auctionbid = class auctionbid extends Struct {};
	__decorate([Struct.field(Name)], auctionbid.prototype, "bidder", void 0);
	__decorate([Struct.field(UInt64)], auctionbid.prototype, "auction_id", void 0);
	__decorate([Struct.field(Asset$1)], auctionbid.prototype, "bid", void 0);
	__decorate([Struct.field(Name)], auctionbid.prototype, "taker_marketplace", void 0);
	auctionbid = __decorate([Struct.type("auctionbid")], auctionbid);
	_Types.auctionbid = auctionbid;
	let auctions_s = class auctions_s extends Struct {};
	__decorate([Struct.field(UInt64)], auctions_s.prototype, "auction_id", void 0);
	__decorate([Struct.field(Name)], auctions_s.prototype, "seller", void 0);
	__decorate([Struct.field(UInt64, { array: true })], auctions_s.prototype, "asset_ids", void 0);
	__decorate([Struct.field(UInt32)], auctions_s.prototype, "end_time", void 0);
	__decorate([Struct.field("bool")], auctions_s.prototype, "assets_transferred", void 0);
	__decorate([Struct.field(Asset$1)], auctions_s.prototype, "current_bid", void 0);
	__decorate([Struct.field(Name)], auctions_s.prototype, "current_bidder", void 0);
	__decorate([Struct.field("bool")], auctions_s.prototype, "claimed_by_seller", void 0);
	__decorate([Struct.field("bool")], auctions_s.prototype, "claimed_by_buyer", void 0);
	__decorate([Struct.field(Name)], auctions_s.prototype, "maker_marketplace", void 0);
	__decorate([Struct.field(Name)], auctions_s.prototype, "taker_marketplace", void 0);
	__decorate([Struct.field(Name)], auctions_s.prototype, "collection_name", void 0);
	__decorate([Struct.field(Float64)], auctions_s.prototype, "collection_fee", void 0);
	auctions_s = __decorate([Struct.type("auctions_s")], auctions_s);
	_Types.auctions_s = auctions_s;
	let balances_s = class balances_s extends Struct {};
	__decorate([Struct.field(Name)], balances_s.prototype, "owner", void 0);
	__decorate([Struct.field(Asset$1, { array: true })], balances_s.prototype, "quantities", void 0);
	balances_s = __decorate([Struct.type("balances_s")], balances_s);
	_Types.balances_s = balances_s;
	let bonusfees_s = class bonusfees_s extends Struct {};
	__decorate([Struct.field(UInt64)], bonusfees_s.prototype, "bonusfee_id", void 0);
	__decorate([Struct.field(Name)], bonusfees_s.prototype, "fee_recipient", void 0);
	__decorate([Struct.field(Float64)], bonusfees_s.prototype, "fee", void 0);
	__decorate([Struct.field(COUNTER_RANGE, { array: true })], bonusfees_s.prototype, "counter_ranges", void 0);
	__decorate([Struct.field("string")], bonusfees_s.prototype, "fee_name", void 0);
	bonusfees_s = __decorate([Struct.type("bonusfees_s")], bonusfees_s);
	_Types.bonusfees_s = bonusfees_s;
	let buyoffers_s = class buyoffers_s extends Struct {};
	__decorate([Struct.field(UInt64)], buyoffers_s.prototype, "buyoffer_id", void 0);
	__decorate([Struct.field(Name)], buyoffers_s.prototype, "buyer", void 0);
	__decorate([Struct.field(Name)], buyoffers_s.prototype, "recipient", void 0);
	__decorate([Struct.field(Asset$1)], buyoffers_s.prototype, "price", void 0);
	__decorate([Struct.field(UInt64, { array: true })], buyoffers_s.prototype, "asset_ids", void 0);
	__decorate([Struct.field("string")], buyoffers_s.prototype, "memo", void 0);
	__decorate([Struct.field(Name)], buyoffers_s.prototype, "maker_marketplace", void 0);
	__decorate([Struct.field(Name)], buyoffers_s.prototype, "collection_name", void 0);
	__decorate([Struct.field(Float64)], buyoffers_s.prototype, "collection_fee", void 0);
	buyoffers_s = __decorate([Struct.type("buyoffers_s")], buyoffers_s);
	_Types.buyoffers_s = buyoffers_s;
	let cancelauct = class cancelauct extends Struct {};
	__decorate([Struct.field(UInt64)], cancelauct.prototype, "auction_id", void 0);
	cancelauct = __decorate([Struct.type("cancelauct")], cancelauct);
	_Types.cancelauct = cancelauct;
	let cancelbuyo = class cancelbuyo extends Struct {};
	__decorate([Struct.field(UInt64)], cancelbuyo.prototype, "buyoffer_id", void 0);
	cancelbuyo = __decorate([Struct.type("cancelbuyo")], cancelbuyo);
	_Types.cancelbuyo = cancelbuyo;
	let cancelsale = class cancelsale extends Struct {};
	__decorate([Struct.field(UInt64)], cancelsale.prototype, "sale_id", void 0);
	cancelsale = __decorate([Struct.type("cancelsale")], cancelsale);
	_Types.cancelsale = cancelsale;
	let canceltbuyo = class canceltbuyo extends Struct {};
	__decorate([Struct.field(UInt64)], canceltbuyo.prototype, "buyoffer_id", void 0);
	canceltbuyo = __decorate([Struct.type("canceltbuyo")], canceltbuyo);
	_Types.canceltbuyo = canceltbuyo;
	let config_s = class config_s extends Struct {};
	__decorate([Struct.field("string")], config_s.prototype, "version", void 0);
	__decorate([Struct.field(UInt64)], config_s.prototype, "sale_counter", void 0);
	__decorate([Struct.field(UInt64)], config_s.prototype, "auction_counter", void 0);
	__decorate([Struct.field(Float64)], config_s.prototype, "minimum_bid_increase", void 0);
	__decorate([Struct.field(UInt32)], config_s.prototype, "minimum_auction_duration", void 0);
	__decorate([Struct.field(UInt32)], config_s.prototype, "maximum_auction_duration", void 0);
	__decorate([Struct.field(UInt32)], config_s.prototype, "auction_reset_duration", void 0);
	__decorate([Struct.field(TOKEN, { array: true })], config_s.prototype, "supported_tokens", void 0);
	__decorate([Struct.field(SYMBOLPAIR, { array: true })], config_s.prototype, "supported_symbol_pairs", void 0);
	__decorate([Struct.field(Float64)], config_s.prototype, "maker_market_fee", void 0);
	__decorate([Struct.field(Float64)], config_s.prototype, "taker_market_fee", void 0);
	__decorate([Struct.field(Name)], config_s.prototype, "atomicassets_account", void 0);
	__decorate([Struct.field(Name)], config_s.prototype, "delphioracle_account", void 0);
	config_s = __decorate([Struct.type("config_s")], config_s);
	_Types.config_s = config_s;
	let convcounters = class convcounters extends Struct {};
	convcounters = __decorate([Struct.type("convcounters")], convcounters);
	_Types.convcounters = convcounters;
	let counters_s = class counters_s extends Struct {};
	__decorate([Struct.field(Name)], counters_s.prototype, "counter_name", void 0);
	__decorate([Struct.field(UInt64)], counters_s.prototype, "counter_value", void 0);
	counters_s = __decorate([Struct.type("counters_s")], counters_s);
	_Types.counters_s = counters_s;
	let createbuyo = class createbuyo extends Struct {};
	__decorate([Struct.field(Name)], createbuyo.prototype, "buyer", void 0);
	__decorate([Struct.field(Name)], createbuyo.prototype, "recipient", void 0);
	__decorate([Struct.field(Asset$1)], createbuyo.prototype, "price", void 0);
	__decorate([Struct.field(UInt64, { array: true })], createbuyo.prototype, "asset_ids", void 0);
	__decorate([Struct.field("string")], createbuyo.prototype, "memo", void 0);
	__decorate([Struct.field(Name)], createbuyo.prototype, "maker_marketplace", void 0);
	createbuyo = __decorate([Struct.type("createbuyo")], createbuyo);
	_Types.createbuyo = createbuyo;
	let createtbuyo = class createtbuyo extends Struct {};
	__decorate([Struct.field(Name)], createtbuyo.prototype, "buyer", void 0);
	__decorate([Struct.field(Asset$1)], createtbuyo.prototype, "price", void 0);
	__decorate([Struct.field(Name)], createtbuyo.prototype, "collection_name", void 0);
	__decorate([Struct.field(UInt64)], createtbuyo.prototype, "template_id", void 0);
	__decorate([Struct.field(Name)], createtbuyo.prototype, "maker_marketplace", void 0);
	createtbuyo = __decorate([Struct.type("createtbuyo")], createtbuyo);
	_Types.createtbuyo = createtbuyo;
	let declinebuyo = class declinebuyo extends Struct {};
	__decorate([Struct.field(UInt64)], declinebuyo.prototype, "buyoffer_id", void 0);
	__decorate([Struct.field("string")], declinebuyo.prototype, "decline_memo", void 0);
	declinebuyo = __decorate([Struct.type("declinebuyo")], declinebuyo);
	_Types.declinebuyo = declinebuyo;
	let delattrroy = class delattrroy extends Struct {};
	__decorate([Struct.field(Name)], delattrroy.prototype, "collection_name", void 0);
	__decorate([Struct.field(UInt64)], delattrroy.prototype, "rule_id", void 0);
	delattrroy = __decorate([Struct.type("delattrroy")], delattrroy);
	_Types.delattrroy = delattrroy;
	let delbonusfee = class delbonusfee extends Struct {};
	__decorate([Struct.field(UInt64)], delbonusfee.prototype, "bonusfee_id", void 0);
	delbonusfee = __decorate([Struct.type("delbonusfee")], delbonusfee);
	_Types.delbonusfee = delbonusfee;
	let delroyalconf = class delroyalconf extends Struct {};
	__decorate([Struct.field(Name)], delroyalconf.prototype, "collection_name", void 0);
	delroyalconf = __decorate([Struct.type("delroyalconf")], delroyalconf);
	_Types.delroyalconf = delroyalconf;
	let deltemplroy = class deltemplroy extends Struct {};
	__decorate([Struct.field(Name)], deltemplroy.prototype, "collection_name", void 0);
	__decorate([Struct.field(Int32)], deltemplroy.prototype, "template_id", void 0);
	deltemplroy = __decorate([Struct.type("deltemplroy")], deltemplroy);
	_Types.deltemplroy = deltemplroy;
	let fulfilltbuyo = class fulfilltbuyo extends Struct {};
	__decorate([Struct.field(Name)], fulfilltbuyo.prototype, "seller", void 0);
	__decorate([Struct.field(UInt64)], fulfilltbuyo.prototype, "buyoffer_id", void 0);
	__decorate([Struct.field(UInt64)], fulfilltbuyo.prototype, "asset_id", void 0);
	__decorate([Struct.field(Asset$1)], fulfilltbuyo.prototype, "expected_price", void 0);
	__decorate([Struct.field(Name)], fulfilltbuyo.prototype, "taker_marketplace", void 0);
	fulfilltbuyo = __decorate([Struct.type("fulfilltbuyo")], fulfilltbuyo);
	_Types.fulfilltbuyo = fulfilltbuyo;
	let init = class init extends Struct {};
	init = __decorate([Struct.type("init")], init);
	_Types.init = init;
	let logauctstart = class logauctstart extends Struct {};
	__decorate([Struct.field(UInt64)], logauctstart.prototype, "auction_id", void 0);
	logauctstart = __decorate([Struct.type("logauctstart")], logauctstart);
	_Types.logauctstart = logauctstart;
	let lognewauct = class lognewauct extends Struct {};
	__decorate([Struct.field(UInt64)], lognewauct.prototype, "auction_id", void 0);
	__decorate([Struct.field(Name)], lognewauct.prototype, "seller", void 0);
	__decorate([Struct.field(UInt64, { array: true })], lognewauct.prototype, "asset_ids", void 0);
	__decorate([Struct.field(Asset$1)], lognewauct.prototype, "starting_bid", void 0);
	__decorate([Struct.field(UInt32)], lognewauct.prototype, "duration", void 0);
	__decorate([Struct.field(UInt32)], lognewauct.prototype, "end_time", void 0);
	__decorate([Struct.field(Name)], lognewauct.prototype, "maker_marketplace", void 0);
	__decorate([Struct.field(Name)], lognewauct.prototype, "collection_name", void 0);
	__decorate([Struct.field(Float64)], lognewauct.prototype, "collection_fee", void 0);
	lognewauct = __decorate([Struct.type("lognewauct")], lognewauct);
	_Types.lognewauct = lognewauct;
	let lognewbuyo = class lognewbuyo extends Struct {};
	__decorate([Struct.field(UInt64)], lognewbuyo.prototype, "buyoffer_id", void 0);
	__decorate([Struct.field(Name)], lognewbuyo.prototype, "buyer", void 0);
	__decorate([Struct.field(Name)], lognewbuyo.prototype, "recipient", void 0);
	__decorate([Struct.field(Asset$1)], lognewbuyo.prototype, "price", void 0);
	__decorate([Struct.field(UInt64, { array: true })], lognewbuyo.prototype, "asset_ids", void 0);
	__decorate([Struct.field("string")], lognewbuyo.prototype, "memo", void 0);
	__decorate([Struct.field(Name)], lognewbuyo.prototype, "maker_marketplace", void 0);
	__decorate([Struct.field(Name)], lognewbuyo.prototype, "collection_name", void 0);
	__decorate([Struct.field(Float64)], lognewbuyo.prototype, "collection_fee", void 0);
	lognewbuyo = __decorate([Struct.type("lognewbuyo")], lognewbuyo);
	_Types.lognewbuyo = lognewbuyo;
	let lognewsale = class lognewsale extends Struct {};
	__decorate([Struct.field(UInt64)], lognewsale.prototype, "sale_id", void 0);
	__decorate([Struct.field(Name)], lognewsale.prototype, "seller", void 0);
	__decorate([Struct.field(UInt64, { array: true })], lognewsale.prototype, "asset_ids", void 0);
	__decorate([Struct.field(Asset$1)], lognewsale.prototype, "listing_price", void 0);
	__decorate([Struct.field(Asset$1.Symbol)], lognewsale.prototype, "settlement_symbol", void 0);
	__decorate([Struct.field(Name)], lognewsale.prototype, "maker_marketplace", void 0);
	__decorate([Struct.field(Name)], lognewsale.prototype, "collection_name", void 0);
	__decorate([Struct.field(Float64)], lognewsale.prototype, "collection_fee", void 0);
	lognewsale = __decorate([Struct.type("lognewsale")], lognewsale);
	_Types.lognewsale = lognewsale;
	let lognewtbuyo = class lognewtbuyo extends Struct {};
	__decorate([Struct.field(UInt64)], lognewtbuyo.prototype, "buyoffer_id", void 0);
	__decorate([Struct.field(Name)], lognewtbuyo.prototype, "buyer", void 0);
	__decorate([Struct.field(Asset$1)], lognewtbuyo.prototype, "price", void 0);
	__decorate([Struct.field(UInt64)], lognewtbuyo.prototype, "template_id", void 0);
	__decorate([Struct.field(Name)], lognewtbuyo.prototype, "maker_marketplace", void 0);
	__decorate([Struct.field(Name)], lognewtbuyo.prototype, "collection_name", void 0);
	__decorate([Struct.field(Float64)], lognewtbuyo.prototype, "collection_fee", void 0);
	lognewtbuyo = __decorate([Struct.type("lognewtbuyo")], lognewtbuyo);
	_Types.lognewtbuyo = lognewtbuyo;
	let logroyattr = class logroyattr extends Struct {};
	__decorate([Struct.field(Name)], logroyattr.prototype, "collection_name", void 0);
	__decorate([Struct.field(UInt64)], logroyattr.prototype, "asset_id", void 0);
	__decorate([Struct.field(UInt64)], logroyattr.prototype, "rule_id", void 0);
	__decorate([Struct.field(ROYALTYPAYOUT, { array: true })], logroyattr.prototype, "payouts", void 0);
	logroyattr = __decorate([Struct.type("logroyattr")], logroyattr);
	_Types.logroyattr = logroyattr;
	let logroydust = class logroydust extends Struct {};
	__decorate([Struct.field(Name)], logroydust.prototype, "collection_name", void 0);
	__decorate([Struct.field(Name)], logroydust.prototype, "collection_author", void 0);
	__decorate([Struct.field(Asset$1)], logroydust.prototype, "amount", void 0);
	logroydust = __decorate([Struct.type("logroydust")], logroydust);
	_Types.logroydust = logroydust;
	let logroyfound = class logroyfound extends Struct {};
	__decorate([Struct.field(Name)], logroyfound.prototype, "collection_name", void 0);
	__decorate([Struct.field(UInt64)], logroyfound.prototype, "asset_id", void 0);
	__decorate([Struct.field(ROYALTYPAYOUT, { array: true })], logroyfound.prototype, "payouts", void 0);
	logroyfound = __decorate([Struct.type("logroyfound")], logroyfound);
	_Types.logroyfound = logroyfound;
	let logroytempl = class logroytempl extends Struct {};
	__decorate([Struct.field(Name)], logroytempl.prototype, "collection_name", void 0);
	__decorate([Struct.field(UInt64)], logroytempl.prototype, "asset_id", void 0);
	__decorate([Struct.field(Int32)], logroytempl.prototype, "template_id", void 0);
	__decorate([Struct.field(ROYALTYPAYOUT, { array: true })], logroytempl.prototype, "payouts", void 0);
	logroytempl = __decorate([Struct.type("logroytempl")], logroytempl);
	_Types.logroytempl = logroytempl;
	let logsalestart = class logsalestart extends Struct {};
	__decorate([Struct.field(UInt64)], logsalestart.prototype, "sale_id", void 0);
	__decorate([Struct.field(UInt64)], logsalestart.prototype, "offer_id", void 0);
	logsalestart = __decorate([Struct.type("logsalestart")], logsalestart);
	_Types.logsalestart = logsalestart;
	let marketplaces_s = class marketplaces_s extends Struct {};
	__decorate([Struct.field(Name)], marketplaces_s.prototype, "marketplace_name", void 0);
	__decorate([Struct.field(Name)], marketplaces_s.prototype, "creator", void 0);
	marketplaces_s = __decorate([Struct.type("marketplaces_s")], marketplaces_s);
	_Types.marketplaces_s = marketplaces_s;
	let migratebal = class migratebal extends Struct {};
	__decorate([Struct.field(Name)], migratebal.prototype, "from", void 0);
	__decorate([Struct.field(Name)], migratebal.prototype, "to", void 0);
	migratebal = __decorate([Struct.type("migratebal")], migratebal);
	_Types.migratebal = migratebal;
	let payauctram = class payauctram extends Struct {};
	__decorate([Struct.field(Name)], payauctram.prototype, "payer", void 0);
	__decorate([Struct.field(UInt64)], payauctram.prototype, "auction_id", void 0);
	payauctram = __decorate([Struct.type("payauctram")], payauctram);
	_Types.payauctram = payauctram;
	let paybuyoram = class paybuyoram extends Struct {};
	__decorate([Struct.field(Name)], paybuyoram.prototype, "payer", void 0);
	__decorate([Struct.field(UInt64)], paybuyoram.prototype, "buyoffer_id", void 0);
	paybuyoram = __decorate([Struct.type("paybuyoram")], paybuyoram);
	_Types.paybuyoram = paybuyoram;
	let paysaleram = class paysaleram extends Struct {};
	__decorate([Struct.field(Name)], paysaleram.prototype, "payer", void 0);
	__decorate([Struct.field(UInt64)], paysaleram.prototype, "sale_id", void 0);
	paysaleram = __decorate([Struct.type("paysaleram")], paysaleram);
	_Types.paysaleram = paysaleram;
	let purchasesale = class purchasesale extends Struct {};
	__decorate([Struct.field(Name)], purchasesale.prototype, "buyer", void 0);
	__decorate([Struct.field(UInt64)], purchasesale.prototype, "sale_id", void 0);
	__decorate([Struct.field(UInt64)], purchasesale.prototype, "intended_delphi_median", void 0);
	__decorate([Struct.field(Name)], purchasesale.prototype, "taker_marketplace", void 0);
	purchasesale = __decorate([Struct.type("purchasesale")], purchasesale);
	_Types.purchasesale = purchasesale;
	let regmarket = class regmarket extends Struct {};
	__decorate([Struct.field(Name)], regmarket.prototype, "creator", void 0);
	__decorate([Struct.field(Name)], regmarket.prototype, "marketplace_name", void 0);
	regmarket = __decorate([Struct.type("regmarket")], regmarket);
	_Types.regmarket = regmarket;
	let royaltyattr_s = class royaltyattr_s extends Struct {};
	__decorate([Struct.field(UInt64)], royaltyattr_s.prototype, "index", void 0);
	__decorate([Struct.field(UInt8)], royaltyattr_s.prototype, "source", void 0);
	__decorate([Struct.field("string")], royaltyattr_s.prototype, "field", void 0);
	__decorate([Struct.field(variant_int8_int16_int32_int64_uint8_uint16_uint32_uint64_float32_float64_string_INT8_VEC_INT16_VEC_INT32_VEC_INT64_VEC_UINT8_VEC_UINT16_VEC_UINT32_VEC_UINT64_VEC_FLOAT_VEC_DOUBLE_VEC_STRING_VEC)], royaltyattr_s.prototype, "value", void 0);
	__decorate([Struct.field(UInt32)], royaltyattr_s.prototype, "weight", void 0);
	__decorate([Struct.field(ROYALTYPAIR, { array: true })], royaltyattr_s.prototype, "recipients", void 0);
	__decorate([Struct.field(Checksum256)], royaltyattr_s.prototype, "lookup_hash", void 0);
	royaltyattr_s = __decorate([Struct.type("royaltyattr_s")], royaltyattr_s);
	_Types.royaltyattr_s = royaltyattr_s;
	let royaltyconf_s = class royaltyconf_s extends Struct {};
	__decorate([Struct.field(Name)], royaltyconf_s.prototype, "collection", void 0);
	__decorate([Struct.field(ROYALTYPAIR, { array: true })], royaltyconf_s.prototype, "founders", void 0);
	__decorate([Struct.field(UInt8)], royaltyconf_s.prototype, "attribute_mode", void 0);
	__decorate([Struct.field(UInt32)], royaltyconf_s.prototype, "split_founders", void 0);
	__decorate([Struct.field(UInt32)], royaltyconf_s.prototype, "split_templates", void 0);
	__decorate([Struct.field(UInt32)], royaltyconf_s.prototype, "split_attributes", void 0);
	royaltyconf_s = __decorate([Struct.type("royaltyconf_s")], royaltyconf_s);
	_Types.royaltyconf_s = royaltyconf_s;
	let royaltytemp_s = class royaltytemp_s extends Struct {};
	__decorate([Struct.field(Int32)], royaltytemp_s.prototype, "template_id", void 0);
	__decorate([Struct.field(ROYALTYPAIR, { array: true })], royaltytemp_s.prototype, "recipients", void 0);
	royaltytemp_s = __decorate([Struct.type("royaltytemp_s")], royaltytemp_s);
	_Types.royaltytemp_s = royaltytemp_s;
	let sales_s = class sales_s extends Struct {};
	__decorate([Struct.field(UInt64)], sales_s.prototype, "sale_id", void 0);
	__decorate([Struct.field(Name)], sales_s.prototype, "seller", void 0);
	__decorate([Struct.field(UInt64, { array: true })], sales_s.prototype, "asset_ids", void 0);
	__decorate([Struct.field(Int64)], sales_s.prototype, "offer_id", void 0);
	__decorate([Struct.field(Asset$1)], sales_s.prototype, "listing_price", void 0);
	__decorate([Struct.field(Asset$1.Symbol)], sales_s.prototype, "settlement_symbol", void 0);
	__decorate([Struct.field(Name)], sales_s.prototype, "maker_marketplace", void 0);
	__decorate([Struct.field(Name)], sales_s.prototype, "collection_name", void 0);
	__decorate([Struct.field(Float64)], sales_s.prototype, "collection_fee", void 0);
	sales_s = __decorate([Struct.type("sales_s")], sales_s);
	_Types.sales_s = sales_s;
	let setattrroy = class setattrroy extends Struct {};
	__decorate([Struct.field(Name)], setattrroy.prototype, "collection_name", void 0);
	__decorate([Struct.field(UInt8)], setattrroy.prototype, "source", void 0);
	__decorate([Struct.field("string")], setattrroy.prototype, "field", void 0);
	__decorate([Struct.field(variant_int8_int16_int32_int64_uint8_uint16_uint32_uint64_float32_float64_string_INT8_VEC_INT16_VEC_INT32_VEC_INT64_VEC_UINT8_VEC_UINT16_VEC_UINT32_VEC_UINT64_VEC_FLOAT_VEC_DOUBLE_VEC_STRING_VEC)], setattrroy.prototype, "value", void 0);
	__decorate([Struct.field(UInt32)], setattrroy.prototype, "rule_weight", void 0);
	__decorate([Struct.field(ROYALTYPAIR, { array: true })], setattrroy.prototype, "recipients", void 0);
	setattrroy = __decorate([Struct.type("setattrroy")], setattrroy);
	_Types.setattrroy = setattrroy;
	let setdefmktcr = class setdefmktcr extends Struct {};
	__decorate([Struct.field(Name)], setdefmktcr.prototype, "new_creator", void 0);
	setdefmktcr = __decorate([Struct.type("setdefmktcr")], setdefmktcr);
	_Types.setdefmktcr = setdefmktcr;
	let setmarketfee = class setmarketfee extends Struct {};
	__decorate([Struct.field(Float64)], setmarketfee.prototype, "maker_market_fee", void 0);
	__decorate([Struct.field(Float64)], setmarketfee.prototype, "taker_market_fee", void 0);
	setmarketfee = __decorate([Struct.type("setmarketfee")], setmarketfee);
	_Types.setmarketfee = setmarketfee;
	let setminbidinc = class setminbidinc extends Struct {};
	__decorate([Struct.field(Float64)], setminbidinc.prototype, "minimum_bid_increase", void 0);
	setminbidinc = __decorate([Struct.type("setminbidinc")], setminbidinc);
	_Types.setminbidinc = setminbidinc;
	let setroyalconf = class setroyalconf extends Struct {};
	__decorate([Struct.field(Name)], setroyalconf.prototype, "collection_name", void 0);
	__decorate([Struct.field(ROYALTYPAIR, { array: true })], setroyalconf.prototype, "founders", void 0);
	__decorate([Struct.field(UInt8)], setroyalconf.prototype, "attribute_mode", void 0);
	__decorate([Struct.field(UInt32)], setroyalconf.prototype, "split_founders", void 0);
	__decorate([Struct.field(UInt32)], setroyalconf.prototype, "split_templates", void 0);
	__decorate([Struct.field(UInt32)], setroyalconf.prototype, "split_attributes", void 0);
	setroyalconf = __decorate([Struct.type("setroyalconf")], setroyalconf);
	_Types.setroyalconf = setroyalconf;
	let settemplroy = class settemplroy extends Struct {};
	__decorate([Struct.field(Name)], settemplroy.prototype, "collection_name", void 0);
	__decorate([Struct.field(Int32)], settemplroy.prototype, "template_id", void 0);
	__decorate([Struct.field(ROYALTYPAIR, { array: true })], settemplroy.prototype, "recipients", void 0);
	settemplroy = __decorate([Struct.type("settemplroy")], settemplroy);
	_Types.settemplroy = settemplroy;
	let setversion = class setversion extends Struct {};
	__decorate([Struct.field("string")], setversion.prototype, "new_version", void 0);
	setversion = __decorate([Struct.type("setversion")], setversion);
	_Types.setversion = setversion;
	let stopbonusfee = class stopbonusfee extends Struct {};
	__decorate([Struct.field(UInt64)], stopbonusfee.prototype, "bonusfee_id", void 0);
	stopbonusfee = __decorate([Struct.type("stopbonusfee")], stopbonusfee);
	_Types.stopbonusfee = stopbonusfee;
	let template_buyoffer_s = class template_buyoffer_s extends Struct {};
	__decorate([Struct.field(UInt64)], template_buyoffer_s.prototype, "buyoffer_id", void 0);
	__decorate([Struct.field(Name)], template_buyoffer_s.prototype, "buyer", void 0);
	__decorate([Struct.field(Asset$1)], template_buyoffer_s.prototype, "price", void 0);
	__decorate([Struct.field(UInt64)], template_buyoffer_s.prototype, "template_id", void 0);
	__decorate([Struct.field(Name)], template_buyoffer_s.prototype, "maker_marketplace", void 0);
	__decorate([Struct.field(Name)], template_buyoffer_s.prototype, "collection_name", void 0);
	__decorate([Struct.field(Float64)], template_buyoffer_s.prototype, "collection_fee", void 0);
	template_buyoffer_s = __decorate([Struct.type("template_buyoffer_s")], template_buyoffer_s);
	_Types.template_buyoffer_s = template_buyoffer_s;
	let withdraw = class withdraw extends Struct {};
	__decorate([Struct.field(Name)], withdraw.prototype, "owner", void 0);
	__decorate([Struct.field(Asset$1)], withdraw.prototype, "token_to_withdraw", void 0);
	withdraw = __decorate([Struct.type("withdraw")], withdraw);
	_Types.withdraw = withdraw;
})(Types$1 || (Types$1 = {}));
const TableMap$1 = {
	auctions: Types$1.auctions_s,
	balances: Types$1.balances_s,
	bonusfees: Types$1.bonusfees_s,
	buyoffers: Types$1.buyoffers_s,
	config: Types$1.config_s,
	counters: Types$1.counters_s,
	marketplaces: Types$1.marketplaces_s,
	royaltyattr: Types$1.royaltyattr_s,
	royaltyconf: Types$1.royaltyconf_s,
	royaltytemp: Types$1.royaltytemp_s,
	sales: Types$1.sales_s,
	tbuyoffers: Types$1.template_buyoffer_s
};
//#endregion
//#region src/contracts/atomictoolsx.ts
var atomictoolsx_exports = __exportAll({
	Contract: () => Contract$1,
	TableMap: () => TableMap,
	Types: () => Types,
	abi: () => abi,
	abiBlob: () => abiBlob
});
const abiBlob = Blob.from("DmVvc2lvOjphYmkvMS4xAAkMYW5ub3VuY2VsaW5rAAQHY3JlYXRvcgRuYW1lA2tleQpwdWJsaWNfa2V5CWFzc2V0X2lkcwh1aW50NjRbXQRtZW1vBnN0cmluZwRhdXRoAAEFbm9uY2UGc3RyaW5nCmNhbmNlbGxpbmsAAQdsaW5rX2lkBnVpbnQ2NAljbGFpbWxpbmsAAwdsaW5rX2lkBnVpbnQ2NAdjbGFpbWVyBG5hbWURY2xhaW1lcl9zaWduYXR1cmUJc2lnbmF0dXJlCGNvbmZpZ19zAAMHdmVyc2lvbgZzdHJpbmcMbGlua19jb3VudGVyBnVpbnQ2NBRhdG9taWNhc3NldHNfYWNjb3VudARuYW1lBGluaXQAAAdsaW5rc19zAAYHbGlua19pZAZ1aW50NjQHY3JlYXRvcgRuYW1lA2tleQpwdWJsaWNfa2V5CWFzc2V0X2lkcwh1aW50NjRbXRJhc3NldHNfdHJhbnNmZXJyZWQEYm9vbARtZW1vBnN0cmluZwxsb2dsaW5rc3RhcnQAAQdsaW5rX2lkBnVpbnQ2NApsb2duZXdsaW5rAAUHbGlua19pZAZ1aW50NjQHY3JlYXRvcgRuYW1lA2tleQpwdWJsaWNfa2V5CWFzc2V0X2lkcwh1aW50NjRbXQRtZW1vBnN0cmluZwcAp4sKTU3nNAxhbm5vdW5jZWxpbmsAAAAAAADQsjYEYXV0aAAAAJwuRoWmQQpjYW5jZWxsaW5rAAAAgNNF6UxECWNsYWltbGluawAAAAAAAJDddARpbml0AJCvyRhOFxmNDGxvZ2xpbmtzdGFydAAAAJwucjUZjQpsb2duZXdsaW5rAAIAAAAAMLcmRQNpNjQAAAhjb25maWdfcwAAAAAADKeLA2k2NAAAB2xpbmtzX3MAAAAAAA==");
const abi = ABI.from(abiBlob);
var Contract$1 = class extends Contract {
	constructor(args) {
		super({
			client: args.client,
			abi,
			account: args.account || Name.from("atomictoolsx")
		});
	}
	action(name, data, options) {
		return super.action(name, data, options);
	}
	table(name, scope) {
		return super.table(name, scope, TableMap[name]);
	}
};
let Types;
(function(_Types) {
	let announcelink = class announcelink extends Struct {};
	__decorate([Struct.field(Name)], announcelink.prototype, "creator", void 0);
	__decorate([Struct.field(PublicKey)], announcelink.prototype, "key", void 0);
	__decorate([Struct.field(UInt64, { array: true })], announcelink.prototype, "asset_ids", void 0);
	__decorate([Struct.field("string")], announcelink.prototype, "memo", void 0);
	announcelink = __decorate([Struct.type("announcelink")], announcelink);
	_Types.announcelink = announcelink;
	let auth = class auth extends Struct {};
	__decorate([Struct.field("string")], auth.prototype, "nonce", void 0);
	auth = __decorate([Struct.type("auth")], auth);
	_Types.auth = auth;
	let cancellink = class cancellink extends Struct {};
	__decorate([Struct.field(UInt64)], cancellink.prototype, "link_id", void 0);
	cancellink = __decorate([Struct.type("cancellink")], cancellink);
	_Types.cancellink = cancellink;
	let claimlink = class claimlink extends Struct {};
	__decorate([Struct.field(UInt64)], claimlink.prototype, "link_id", void 0);
	__decorate([Struct.field(Name)], claimlink.prototype, "claimer", void 0);
	__decorate([Struct.field(Signature)], claimlink.prototype, "claimer_signature", void 0);
	claimlink = __decorate([Struct.type("claimlink")], claimlink);
	_Types.claimlink = claimlink;
	let config_s = class config_s extends Struct {};
	__decorate([Struct.field("string")], config_s.prototype, "version", void 0);
	__decorate([Struct.field(UInt64)], config_s.prototype, "link_counter", void 0);
	__decorate([Struct.field(Name)], config_s.prototype, "atomicassets_account", void 0);
	config_s = __decorate([Struct.type("config_s")], config_s);
	_Types.config_s = config_s;
	let init = class init extends Struct {};
	init = __decorate([Struct.type("init")], init);
	_Types.init = init;
	let links_s = class links_s extends Struct {};
	__decorate([Struct.field(UInt64)], links_s.prototype, "link_id", void 0);
	__decorate([Struct.field(Name)], links_s.prototype, "creator", void 0);
	__decorate([Struct.field(PublicKey)], links_s.prototype, "key", void 0);
	__decorate([Struct.field(UInt64, { array: true })], links_s.prototype, "asset_ids", void 0);
	__decorate([Struct.field("bool")], links_s.prototype, "assets_transferred", void 0);
	__decorate([Struct.field("string")], links_s.prototype, "memo", void 0);
	links_s = __decorate([Struct.type("links_s")], links_s);
	_Types.links_s = links_s;
	let loglinkstart = class loglinkstart extends Struct {};
	__decorate([Struct.field(UInt64)], loglinkstart.prototype, "link_id", void 0);
	loglinkstart = __decorate([Struct.type("loglinkstart")], loglinkstart);
	_Types.loglinkstart = loglinkstart;
	let lognewlink = class lognewlink extends Struct {};
	__decorate([Struct.field(UInt64)], lognewlink.prototype, "link_id", void 0);
	__decorate([Struct.field(Name)], lognewlink.prototype, "creator", void 0);
	__decorate([Struct.field(PublicKey)], lognewlink.prototype, "key", void 0);
	__decorate([Struct.field(UInt64, { array: true })], lognewlink.prototype, "asset_ids", void 0);
	__decorate([Struct.field("string")], lognewlink.prototype, "memo", void 0);
	lognewlink = __decorate([Struct.type("lognewlink")], lognewlink);
	_Types.lognewlink = lognewlink;
})(Types || (Types = {}));
const TableMap = {
	config: Types.config_s,
	links: Types.links_s
};
//#endregion
//#region src/utility.ts
var KitUtility = class {
	constructor(url, chain, options) {
		this.url = url;
		this.chain = chain;
		this.client = options?.client || new APIClient({ url: this.chain.url });
		this.atomicClient = options?.atomicClient || new AtomicAssetsAPIClient(new APIClient({ provider: new FetchProvider(this.url) }));
		this.assetsContract = options?.assetsContract || new Contract$3({ client: this.client });
		this.marketContract = options?.marketContract || new Contract$2({ client: this.client });
		this.toolsContract = options?.toolsContract || new Contract$1({ client: this.client });
	}
};
//#endregion
//#region src/kits/atomicassets.ts
var AtomicAssetsKit = class {
	constructor(url, chain, options) {
		this.utility = new KitUtility(url, chain, options);
	}
	async loadCollection(collectionName) {
		const data = await this.utility.atomicClient.atomicassets.v1.get_collection(collectionName);
		return Collection.from(data.data, this.utility);
	}
	createCollection(value) {
		return this.utility.assetsContract.action("createcol", value);
	}
	async loadSchema(collectionName, schemaName) {
		const data = await this.utility.atomicClient.atomicassets.v1.get_schema(collectionName, schemaName);
		return Schema.from(data.data, this.utility);
	}
	createSchema(value) {
		return this.utility.assetsContract.action("createschema", value);
	}
	async loadTemplate(collectionName, templateId) {
		const data = await this.utility.atomicClient.atomicassets.v1.get_template(collectionName, templateId);
		return Template.from(data.data, this.utility);
	}
	createTemplate(value) {
		return this.utility.assetsContract.action("createtempl", value);
	}
	async loadAsset(assetId) {
		const data = await this.utility.atomicClient.atomicassets.v1.get_asset(assetId);
		return Asset.from(data.data, this.utility);
	}
	mintAsset(value) {
		return this.utility.assetsContract.action("mintasset", value);
	}
	async loadOffer(offerId) {
		const data = await this.utility.atomicClient.atomicassets.v1.get_offer(offerId);
		return Offer.from(data.data, this.utility);
	}
	createOffer(value) {
		return this.utility.assetsContract.action("createoffer", value);
	}
	transfer(value) {
		return this.utility.assetsContract.action("transfer", value);
	}
	withdraw(value) {
		return this.utility.assetsContract.action("withdraw", value);
	}
	addConfToken(value) {
		return this.utility.assetsContract.action("addconftoken", value);
	}
	adminColEdit(value) {
		return this.utility.assetsContract.action("admincoledit", value);
	}
	announceDepo(value) {
		return this.utility.assetsContract.action("announcedepo", value);
	}
	setVersion(value) {
		return this.utility.assetsContract.action("setversion", value);
	}
};
//#endregion
//#region src/kits/atomicmarket.ts
var AtomicMarketKit = class {
	constructor(url, chain, options) {
		this.utility = new KitUtility(url, chain, options);
	}
	async loadAuction(auctionId) {
		const data = await this.utility.atomicClient.atomicmarket.v1.get_auction(auctionId);
		return Auction.from(data.data, this.utility);
	}
	announceAuction(value) {
		return this.utility.marketContract.action("announceauct", value);
	}
	async loadSale(saleId) {
		const data = await this.utility.atomicClient.atomicmarket.v1.get_sale(saleId);
		return Sale.from(data.data, this.utility);
	}
	announceSale(value) {
		return this.utility.marketContract.action("announcesale", value);
	}
	async loadBuyoffer(buyofferId) {
		const data = await this.utility.atomicClient.atomicmarket.v1.get_buyoffer(buyofferId);
		return Buyoffer.from(data.data, this.utility);
	}
	createBuyo(value) {
		return this.utility.marketContract.action("createbuyo", value);
	}
	addBonusfeeCounter(value) {
		return this.utility.marketContract.action("addafeectr", value);
	}
	addBonusfee(value) {
		return this.utility.marketContract.action("addbonusfee", value);
	}
	delBonusfee(value) {
		return this.utility.marketContract.action("delbonusfee", value);
	}
	stopBonusfee(value) {
		return this.utility.marketContract.action("stopbonusfee", value);
	}
	addConfToken(value) {
		return this.utility.marketContract.action("addconftoken", value);
	}
	addDelphi(value) {
		return this.utility.marketContract.action("adddelphi", value);
	}
	registerMarketplace(value) {
		return this.utility.marketContract.action("regmarket", value);
	}
	setMarketfee(value) {
		return this.utility.marketContract.action("setmarketfee", value);
	}
	setMinbidinc(value) {
		return this.utility.marketContract.action("setminbidinc", value);
	}
	setVersion(value) {
		return this.utility.marketContract.action("setversion", value);
	}
	withdraw(value) {
		return this.utility.marketContract.action("withdraw", value);
	}
};
//#endregion
//#region src/kits/atomictools.ts
var AtomicToolsKit = class {
	constructor(url, chain, options) {
		this.utility = new KitUtility(url, chain, options);
	}
	async loadLink(linkId) {
		const data = await this.utility.atomicClient.atomictools.v1.get_link(linkId);
		return Link.from(data.data, this.utility);
	}
	announceLink(value) {
		return this.utility.toolsContract.action("announcelink", value);
	}
};
//#endregion
export { Asset, AtomicAssetsAPIClient, atomicassets_exports as AtomicAssetsContract, AtomicAssetsKit, atomicmarket_exports as AtomicMarketContract, AtomicMarketKit, atomictoolsx_exports as AtomicToolsContract, AtomicToolsKit, Auction, Buyoffer, Collection, KitUtility, Link, Offer, Sale, Schema, Template, types_exports as Types };

//# sourceMappingURL=atomicassets.m.js.map